// German translations - Complete
export default {
  nav: {
    home: 'Startseite',
    dashboard: 'Dashboard',
    login: 'Anmelden',
    register: 'Registrieren',
    logout: 'Abmelden',
    settings: 'Einstellungen',
    admin: 'Admin',
    menu: 'Menü',
    createQuiz: 'Quiz erstellen',
    createQuestionnaire: 'Fragebogen erstellen',
    createEvent: 'Ereignis erstellen',
    quizMusic: 'Quiz-Musik',
    users: 'Benutzer',
    backToDashboard: 'Zurück zum Dashboard'
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    add: 'Hinzufügen',
    search: 'Suchen',
    filter: 'Filtern',
    loading: 'Laden...',
    error: 'Fehler',
    success: 'Erfolg',
    confirm: 'Bestätigen',
    confirmDelete: 'Löschung bestätigen',
    confirmDeleteMessage: 'Sind Sie sicher, dass Sie löschen möchten',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Vorherige',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    true: 'Wahr',
    false: 'Falsch',
    all: 'Alle',
    none: 'Keine',
    download: 'Herunterladen',
    share: 'Teilen',
    copy: 'Kopieren',
    copied: 'Kopiert!',
    play: 'Spielen',
    view: 'Ansehen',
    actions: 'Aktionen',
    logoutSuccess: 'Erfolgreich abgemeldet',
    or: 'oder',
    and: 'und',
    welcome: 'Willkommen',
    required: 'Erforderlich',
    optional: 'Optional',
    important: 'Wichtig',
    submit: 'Absenden',
    reset: 'Zurücksetzen',
    start: 'Starten',
    stop: 'Stoppen',
    pause: 'Pause',
    resume: 'Fortsetzen',
    finish: 'Beenden',
    continue: 'Weiter',
    skip: 'Überspringen',
    retry: 'Wiederholen',
    refresh: 'Aktualisieren',
    more: 'Mehr',
    less: 'Weniger',
    show: 'Anzeigen',
    hide: 'Verbergen',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    select: 'Auswählen',
    selected: 'Ausgewählt',
    upload: 'Hochladen',
    uploading: 'Wird hochgeladen...',
    preview: 'Vorschau',
    export: 'Exportieren',
    import: 'Importieren',
    print: 'Drucken',
    send: 'Senden',
    sending: 'Wird gesendet...',
    sent: 'Gesendet',
    noResults: 'Keine Ergebnisse',
    loadMore: 'Mehr laden',
    seeAll: 'Alle anzeigen',
    duplicate: 'Duplizieren',
    saving: 'Speichern...',
    saveChanges: 'Änderungen speichern',
    copy: 'Kopie',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    from: 'Von',
    to: 'An',
    date: 'Datum',
    time: 'Uhrzeit',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    description: 'Beschreibung',
    title: 'Titel',
    status: 'Status',
    type: 'Typ',
    category: 'Kategorie',
    total: 'Gesamt',
    quantity: 'Menge',
    price: 'Preis',
    free: 'Kostenlos',
    new: 'Neu',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    public: 'Öffentlich',
    private: 'Privat',
    draft: 'Entwurf',
    published: 'Veröffentlicht',
    admin: 'Admin',
    user: 'Benutzer',
    madeWith: 'Erstellt mit',
    backToHome: 'Zurück zur Startseite',
    checking: 'Überprüfung...',
    verification: 'Überprüfung',
    access: 'Zugang'
  },

  messages: {
    success: {
      saved: 'Erfolgreich gespeichert',
      deleted: 'Erfolgreich gelöscht',
      updated: 'Erfolgreich aktualisiert',
      created: 'Erfolgreich erstellt',
      copied: 'Kopiert!',
      linkCopied: 'Link kopiert!',
      emailSent: 'E-Mail gesendet!',
      emailVerified: 'E-Mail verifiziert! Weiterleitung...',
      emailAlreadyVerified: 'Ihre E-Mail ist bereits verifiziert!',
      verificationEmailSent: '📧 Verifizierungs-E-Mail gesendet! Überprüfen Sie auch Ihren Spam-Ordner.',
      tableCreated: 'Tisch erfolgreich erstellt',
      tableUpdated: 'Tisch erfolgreich aktualisiert',
      tableDeleted: 'Tisch gelöscht',
      tableAdded: 'Tisch hinzugefügt',
      guestAssigned: 'Gast zugewiesen',
      guestRemoved: 'Gast vom Tisch entfernt',
      planSaved: 'Plan gespeichert',
      questionDuplicated: 'Frage dupliziert',
      questionnaireUpdated: 'Fragebogen aktualisiert!',
      quizUpdated: 'Quiz aktualisiert!',
      responseDeleted: 'Antwort gelöscht',
      musicDeleted: 'Musik gelöscht',
      accountCreatedResend: 'Konto erstellt! Klicken Sie auf "E-Mail erneut senden", um den Verifizierungslink zu erhalten.'
    },
    error: {
      generic: 'Ein Fehler ist aufgetreten',
      loading: 'Fehler beim Laden',
      saving: 'Fehler beim Speichern',
      deleting: 'Fehler beim Löschen',
      creating: 'Fehler beim Erstellen',
      updating: 'Fehler beim Aktualisieren',
      unauthorized: 'Nicht autorisiert',
      notFound: 'Element nicht gefunden',
      quizNotFound: 'Quiz nicht gefunden',
      questionnaireNotFound: 'Fragebogen nicht gefunden',
      eventNotFound: 'Veranstaltung nicht gefunden',
      sessionNotFound: 'Sitzung nicht gefunden',
      sessionStarted: 'Diese Sitzung hat bereits begonnen',
      accessDenied: 'Sie sind nicht berechtigt, auf diese Seite zuzugreifen',
      adminOnly: 'Nur für Administratoren',
      logoutError: 'Fehler beim Abmelden',
      tooManyAttempts: 'Zu viele Versuche. Versuchen Sie es in ein paar Minuten erneut.',
      sessionExpired: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
      emailNotVerified: 'E-Mail noch nicht verifiziert. Überprüfen Sie Ihr Postfach und den Spam-Ordner.',
      emailVerifiedNotValidated: 'E-Mail verifiziert aber Konto nicht validiert. Kontaktieren Sie den Administrator.',
      qrCodeNotRecognized: 'QR-Code nicht erkannt',
      qrCodeWrongEvent: 'Dieses Ticket gehört nicht zu dieser Veranstaltung',
      qrCodeReadError: 'Fehler beim Lesen des QR-Codes',
      playbackError: 'Wiedergabefehler',
      assignmentError: 'Fehler bei der Zuweisung'
    },
    validation: {
      required: 'Dieses Feld ist erforderlich',
      titleRequired: 'Titel ist erforderlich',
      nameRequired: 'Tischname erforderlich',
      tableNameRequired: 'Bitte geben Sie einen Tischnamen ein',
      sessionCodeRequired: 'Bitte geben Sie einen Sitzungscode ein',
      minQuestions: 'Fügen Sie mindestens eine Frage hinzu',
      minOneQuestion: 'Mindestens 1 Frage erforderlich',
      questionTextRequired: 'Alle Fragen müssen einen Text haben',
      minOptions: 'Mindestens 2 Optionen erforderlich',
      passwordMinLength: 'Passwort muss mindestens 8 Zeichen haben',
      passwordLowercase: 'Passwort muss mindestens einen Kleinbuchstaben enthalten',
      passwordUppercase: 'Passwort muss mindestens einen Großbuchstaben enthalten',
      passwordSpecialChar: 'Passwort muss mindestens ein Sonderzeichen enthalten (z.B. #, @, !)'
    },
    confirm: {
      delete: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
      logout: 'Sind Sie sicher, dass Sie sich abmelden möchten?'
    }
  },

  pendingValidation: {
    title: 'Verifizieren Sie Ihre E-Mail',
    emailSentTo: 'Eine Verifizierungs-E-Mail wurde gesendet an',
    checkInbox: '📧 Klicken Sie auf den Link in der E-Mail, um Ihre Adresse zu verifizieren. Überprüfen Sie auch Ihren Spam-Ordner.',
    accessGranted: '✅ Sobald Ihre E-Mail verifiziert ist, haben Sie sofortigen Zugang zu Ihrem Konto!',
    iVerified: 'Ich habe meine E-Mail verifiziert',
    resendEmail: 'Verifizierungs-E-Mail erneut senden',
    logout: 'Abmelden'
  },

  home: {
    title: 'Willkommen bei HugoQuiz',
    subtitle: 'Erstellen Sie Quiz, Fragebögen und verwalten Sie Ihre Veranstaltungen',
    startFree: 'Kostenlos starten',
    login: 'Anmelden',
    goToDashboard: 'Zum Dashboard',
    features: {
      quiz: 'Interaktive Quiz',
      quizDesc: 'Erstellen Sie fesselnde Quiz mit Timer und Rangliste',
      quizLive: 'Live-Mehrspieler-Quiz',
      quizLiveDesc: 'Veranstalten Sie Live-Quiz mit gleichzeitig verbundenen Teilnehmern',
      questionnaire: 'Bedingte Fragebögen',
      questionnaireDesc: 'Intelligente Formulare mit bedingter Logik und dynamischer Navigation',
      events: 'Geschenklisten',
      eventsDesc: 'Erstellen Sie Listen für Hochzeiten, Geburtstage und alle Ihre Veranstaltungen'
    },
    highlights: {
      timer: 'Anpassbarer Timer',
      realTimeScores: 'Echtzeit-Punktzahlen',
      kahootMusic: 'Kahoot-Musik',
      presenterMode: 'Präsentator-Modus',
      liveRanking: 'Live-Rangliste',
      upTo100Players: 'Bis zu 100 Spieler',
      conditionalLogic: 'IF/ELSE-Logik',
      questionTypes: '11 Fragetypen',
      responseAnalysis: 'Antwortanalyse',
      multiReservations: 'Mehrfachreservierungen',
      photoGallery: 'Fotogalerie',
      pdfInvitations: 'PDF-Einladungen'
    },
    eventTypes: {
      wedding: 'Hochzeit',
      birthday: 'Geburtstag',
      birth: 'Geburt',
      baptism: 'Taufe',
      housewarming: 'Einweihungsfeier',
      christmas: 'Weihnachten'
    },
    stats: {
      free: 'Kostenlos',
      unlimited: 'Unbegrenzte Quiz',
      questionTypes: 'Fragetypen',
      hdImages: 'HD-Bilder'
    },
    cta: {
      createFirstQuiz: 'Mein erstes Quiz erstellen',
      discoverFeatures: 'Funktionen entdecken',
      watchDemo: 'Demo ansehen',
      createFreeAccount: 'Kostenloses Konto erstellen',
      readyToCreate: 'Bereit, etwas Erstaunliches zu erstellen?',
      joinHugoQuiz: 'Werden Sie Teil von HugoQuiz und verwandeln Sie Ihre Veranstaltungen in unvergessliche Erlebnisse.',
      foreverFree: '100% kostenlos, für immer.'
    },
    footer: {
      madeWith: 'Erstellt mit',
      forYourEvents: 'für Ihre Veranstaltungen',
      createdWith: 'Erstellt mit'
    },
    sections: {
      allYouNeed: 'Alles was Sie brauchen',
      allYouNeedDesc: 'Eine komplette Suite von Tools für unvergessliche interaktive Erlebnisse',
      interactiveQuiz: 'Interaktive Quiz',
      kahootStyle: 'Kahoot-Stil',
      quizDetailDesc: 'Erstellen Sie fesselnde Quiz mit Timer, Punktesystem, Hintergrundmusik und Ranglisten. Perfekt für Bildung, Teambuilding oder Partys mit Freunden!',
      giftLists: 'Geschenklisten',
      forAllEvents: 'Für alle Ihre Veranstaltungen',
      giftListDesc: 'Erstellen Sie eine elegante Geschenkliste, teilen Sie sie mit Ihren Lieben und lassen Sie sie einfach reservieren. Fotogalerie, personalisierte Geschichte und PDF-Einladungen inklusive!',
      questionTypesTitle: '11 Fragetypen',
      questionTypesDesc: 'Von klassischen Fragen bis zu erweiterten Formularen ist alles möglich',
      simpleAsHello: 'Einfach wie Hallo',
      createShareIn4Steps: 'Erstellen und teilen in 4 Schritten'
    },
    quizFeatures: {
      customTimer: 'Anpassbarer Timer pro Frage (5-120 Sek.)',
      kahootMusic: 'Integrierte Kahoot-Hintergrundmusik',
      leaderboardBonus: 'Rangliste mit Geschwindigkeitsbonus',
      sevenQuestionTypes: '7 verschiedene Fragetypen',
      mobileCompatible: 'Mobil- und Tablet-kompatibel',
      musicOn: 'Musik AN',
      players: 'Spieler'
    },
    giftFeatures: {
      photoGallery: 'Fotogalerie mit animierter Diashow',
      pdfInvites: 'Personalisierte PDF-Einladungen',
      multiReservations: 'Mehrfachreservierungen pro Geschenk',
      anonymousOption: 'Anonyme Option für Gäste',
      reservedBy: 'Reserviert von',
      persons: 'Personen'
    },
    howItWorks: {
      step: 'Schritt',
      step1Title: 'Registrieren',
      step1Desc: 'Erstellen Sie in 30 Sekunden ein kostenloses Konto',
      step2Title: 'Erstellen',
      step2Desc: 'Quiz, Fragebogen oder Geschenkliste',
      step3Title: 'Teilen',
      step3Desc: 'Senden Sie den Link an Ihre Teilnehmer',
      step4Title: 'Analysieren',
      step4Desc: 'Ergebnisse in Echtzeit anzeigen'
    },
    navbar: {
      quiz: 'Quiz',
      events: 'Veranstaltungen',
      gifts: 'Geschenke',
      interactiveQuiz: 'Interaktive Quiz',
      liveQuiz: 'Live Quiz',
      questionnaires: 'Fragebögen',
      giftLists: 'Geschenklisten',
      features: 'Funktionen'
    },
    // Hero section
    heroTitle: 'Unvergessliche Erlebnisse schaffen',
    // Quiz preview mockup
    quizPreview: {
      questionNumber: 'Frage 3/10',
      sampleQuestion: 'Was ist die Hauptstadt von Frankreich?',
      option1: 'Paris',
      option2: 'London',
      option3: 'Berlin',
      option4: 'Madrid'
    },
    // Gift list preview mockup
    giftPreview: {
      weddingTitle: 'Hochzeit von Marie & Peter',
      weddingDate: '15. Juni 2025',
      item1: 'Küchenmaschine',
      item2: 'Geschirrservice',
      item3: 'Hochzeitsreise',
      reservedBy1: 'Tante Sophie'
    },
    // Guest list preview mockup
    guestListPreview: {
      guest1: 'Marie Müller',
      guest2: 'Peter Schmidt',
      guest3: 'Sophie Weber'
    },
    // Guestbook preview mockup
    guestbookPreview: {
      author1: 'Oma Johanna',
      message1: 'Herzlichen Glückwunsch, meine Lieben! 💕',
      author2: 'Thomas & Lea',
      message2: 'Ein magischer Abend, danke!',
      author3: 'Onkel Hans',
      message3: 'Es lebe das Brautpaar! 🥂'
    },
    // Guest list section
    guestList: {
      title: 'Gästeliste',
      persons: 'Pers.',
      confirmed: 'bestätigt',
      heading: 'Verwalten Sie Ihre Gäste',
      subheading: 'ganz einfach',
      description: 'Verfolgen Sie Bestätigungen, senden Sie Erinnerungen und exportieren Sie Ihre Liste. Alles ist zentralisiert für perfekte Organisation.',
      feature1: 'Personalisierte E-Mail-Einladungen',
      feature2: 'Echtzeit-Bestätigungsverfolgung',
      feature3: 'PDF- und Excel-Export'
    },
    // Guestbook section
    guestbook: {
      heading: 'Digitales Gästebuch',
      subheading: 'Erinnerungen für immer',
      description: 'Ihre Gäste hinterlassen ihre Nachrichten und Fotos. Erstellen Sie ein einzigartiges Erinnerungsalbum, das Sie für immer schätzen werden.',
      feature1: 'Text- und Audionachrichten',
      feature2: 'Fotos und Videos der Gäste',
      feature3: 'Anpassbares Design',
      bookTitle: 'Gästebuch'
    },
    // Seating plan section
    seating: {
      heading: 'Interaktiver Sitzplan',
      subheading: 'mit Tischplatzierung',
      description: 'Erstellen Sie Ihren Sitzplan per Drag-and-Drop. Weisen Sie Ihre Gäste den Tischen zu und visualisieren Sie das Ergebnis in Echtzeit.',
      feature1: 'Intuitive Drag-and-Drop-Oberfläche',
      feature2: 'Automatische Platzzuweisung',
      feature3: 'Export und Druck des Plans',
      preview: 'Sitzplan',
      tables: 'Tische',
      seats: 'Plätze',
      dragDrop: 'Drag-and-Drop'
    },
    // Pro section
    pro: {
      badge: 'Pro-Tarif',
      heading: 'Auf die nächste Stufe bringen',
      description: 'Schalten Sie alle Funktionen frei und genießen Sie unbegrenzte Teilnehmer für Ihre Quiz und Veranstaltungen.',
      feature1Title: 'Unbegrenzte Teilnehmer',
      feature1Desc: 'Keine 5-Spieler-Grenze mehr',
      feature2Title: 'Fragebögen',
      feature2Desc: 'Erstellen Sie vollständige Umfragen',
      feature3Title: 'Veranstaltungen',
      feature3Desc: 'Geschenklisten, Gäste, Sitzplan',
      price: 'Ab 5€',
      period: '/Monat',
      cta: 'Tarife ansehen'
    }
  },
  
  // Footer
  footer: {
    description: 'Die interaktive Plattform zum Erstellen von Quiz, Fragebögen und zur Verwaltung Ihrer Veranstaltungen.',
    support: 'Support',
    legal: 'Impressum',
    terms: 'Nutzungsbedingungen',
    privacy: 'Datenschutz',
    help: 'Hilfe',
    rights: 'Alle Rechte vorbehalten.'
  },

  // Hilfe
  help: {
    hero: {
      title: 'HugoQuiz Hilfezentrum',
      subtitle: 'Entdecken Sie alle Funktionen von HugoQuiz und lernen Sie, sie effektiv zu nutzen, um unvergessliche Veranstaltungen zu erstellen.'
    },
    tabs: {
      faq: 'Häufig gestellte Fragen',
      docs: 'Vollständige Dokumentation'
    },
    tips: {
      title: 'Tipps für den Einstieg',
      tip1: 'Erstellen Sie zunächst eine einfache Veranstaltung, um sich mit der Oberfläche vertraut zu machen.',
      tip2: 'Verwenden Sie Quiz-Vorlagen, um Zeit bei der Erstellung zu sparen.',
      tip3: 'Testen Sie Ihr Quiz immer im Vorschaumodus, bevor Sie es teilen.',
      tip4: 'Überprüfen Sie nach jeder Veranstaltung die Statistiken, um sich zu verbessern.'
    },
    faq: {
      title: 'Häufig gestellte Fragen',
      q1: {
        question: 'Wie erstelle ich meine erste Veranstaltung?',
        answer: 'Um Ihre erste Veranstaltung zu erstellen, melden Sie sich bei Ihrem HugoQuiz-Konto an und klicken Sie dann auf "Veranstaltung erstellen" in Ihrem Dashboard. Geben Sie die grundlegenden Informationen ein (Name, Datum, Ort, Beschreibung) und passen Sie die Optionen nach Ihren Bedürfnissen an. Anschließend können Sie Gäste hinzufügen, ein Programm erstellen, Tische verwalten und vieles mehr.'
      },
      q2: {
        question: 'Was ist der Unterschied zwischen einem Live-Quiz und einem asynchronen Quiz?',
        answer: 'Ein Live-Quiz wird in Echtzeit gespielt, wobei alle Teilnehmer gleichzeitig verbunden sind. Der Moderator steuert das Tempo und zeigt die Fragen nacheinander an. Ideal für Partys, Hochzeiten oder Teambuildings.\n\nEin asynchrones Quiz ermöglicht es den Teilnehmern, in ihrem eigenen Tempo zu spielen, wann immer sie möchten. Jeder beantwortet die Fragen individuell und die Ergebnisse werden automatisch zusammengestellt. Perfekt für Schulungen oder Umfragen.'
      },
      q3: {
        question: 'Wie lade ich Teilnehmer zu meiner Veranstaltung ein?',
        answer: 'Sie können Teilnehmer auf verschiedene Arten einladen:\n• Kontaktdaten manuell zur Gästeliste hinzufügen\n• Excel/CSV-Datei mit der Gästeliste importieren\n• Einladungslink oder QR-Code teilen\n• E-Mail-Einladungen direkt von HugoQuiz senden\n\nJeder Gast erhält einen personalisierten Zugang mit einem einzigartigen QR-Code für den Veranstaltungstag.'
      },
      q4: {
        question: 'Wie funktioniert das Tisch- und Sitzplan-System?',
        answer: 'Das Tischverwaltungssystem ermöglicht Ihnen:\n• Verschiedene Tischtypen erstellen (rund, rechteckig, quadratisch)\n• Anzahl der Plätze pro Tisch festlegen\n• Gäste per Drag & Drop an Tische setzen\n• Den Sitzplan in Echtzeit visualisieren\n• Personalisierte Tischkarten und den vollständigen Plan drucken\n\nDer interaktive Sitzplan hilft Ihnen, das Layout zu optimieren und Gästeaffinitäten zu verwalten.'
      },
      q5: {
        question: 'Kann ich das Erscheinungsbild meiner Quizze anpassen?',
        answer: 'Ja, HugoQuiz bietet viele Anpassungsoptionen:\n• Aus mehreren visuellen Themen wählen\n• Ihr Logo und Ihre Bilder hinzufügen\n• Hauptfarben anpassen\n• Hintergrundmusik hinzufügen\n• Zeit pro Frage konfigurieren\n• Endnachrichten anpassen\n\nDies ermöglicht es Ihnen, ein Erlebnis zu schaffen, das mit Ihrer Veranstaltungsidentität übereinstimmt.'
      },
      q6: {
        question: 'Wie funktioniert das digitale Gästebuch?',
        answer: 'Das digitale Gästebuch ermöglicht es Ihren Gästen, während oder nach der Veranstaltung Nachrichten, Fotos und Videos zu hinterlassen. Sie können:\n• Persönliche Nachrichten schreiben\n• Fotos oder Selfies hinzufügen\n• Sprachnachrichten aufnehmen\n• Auf Nachrichten anderer reagieren\n\nAlle Erinnerungen werden gespeichert und Sie können sie als PDF oder Fotoalbum exportieren.'
      },
      q7: {
        question: 'Wie scanne ich Tickets/QR-Codes am Veranstaltungstag?',
        answer: 'Am Veranstaltungstag verwenden Sie die Funktion "QR scannen" in Ihrem Dashboard:\n• Erlauben Sie den Kamerazugriff auf Ihrem Gerät\n• Scannen Sie den QR-Code jedes Gastes\n• Das System bestätigt sofort die Gültigkeit\n• Der Gast wird automatisch als "angekommen" markiert\n• Sie sehen die Anwesenheitsrate in Echtzeit\n\nSie können mehrere Geräte gleichzeitig verwenden, um den Check-in zu beschleunigen.'
      },
      q8: {
        question: 'Wie erstelle ich bedingte Fragen in einem Fragebogen?',
        answer: 'Bedingte Fragen ermöglichen es Ihnen, bestimmte Fragen basierend auf vorherigen Antworten anzuzeigen. Um sie zu konfigurieren:\n1. Erstellen Sie Ihre Hauptfrage\n2. Aktivieren Sie die Option "Bedingte Frage"\n3. Definieren Sie die Bedingung (z.B. "Wenn Antwort = Ja")\n4. Wählen Sie die Frage aus, die angezeigt werden soll\n\nPerfekt für RSVPs (Ernährungseinschränkungen nur abfragen, wenn die Person ihre Teilnahme bestätigt).'
      },
      q9: {
        question: 'Wie funktioniert das Abonnement und kann ich den Plan wechseln?',
        answer: 'HugoQuiz bietet mehrere Pläne an:\n• Kostenlos: Grundfunktionen, perfekt zum Entdecken\n• Premium: Erweiterte Funktionen für Einzelpersonen\n• Business: Alle Funktionen + Priority-Support\n\nSie können den Plan jederzeit wechseln. Die Änderung wird sofort wirksam und der Betrag wird anteilig berechnet.'
      },
      q10: {
        question: 'Sind meine Daten sicher?',
        answer: 'Datensicherheit hat bei uns Priorität:\n• Hosting auf sicheren europäischen Servern\n• SSL/TLS-Verschlüsselung für alle Kommunikationen\n• Vollständige DSGVO-Konformität\n• Tägliche automatische Backups\n• Sichere Authentifizierung\n• Daten jederzeit löschbar\n\nSie bleiben Eigentümer Ihrer Daten und können sie jederzeit exportieren.'
      },
      q11: {
        question: 'Wie füge ich Musik zu meinem Quiz hinzu?',
        answer: 'Um Musik zu Ihrem Quiz hinzuzufügen:\n1. Öffnen Sie die Quiz-Einstellungen\n2. Abschnitt "Musik und Sounds"\n3. Laden Sie Ihre Audiodateien hoch (MP3, WAV)\n4. Konfigurieren Sie Musik für jede Phase:\n   • Warten auf Spieler\n   • Während der Fragen\n   • Richtige/falsche Antwort\n   • Finales Podium\n\nSie können auch die integrierte lizenzfreie Musikbibliothek verwenden.'
      },
      q12: {
        question: 'Wie sehe ich die Statistiken meiner Veranstaltung?',
        answer: 'Vollständige Statistiken sind von jeder Veranstaltungsseite aus zugänglich:\n• RSVP-Antwortrate mit zeitlicher Entwicklung\n• Anwesenheitsstatistiken am Tag\n• Detaillierte Quiz-Statistiken (Punkte, Antwortzeiten)\n• Anwesenheitsrate am D-Day\n• Gästebuch-Nachrichten\n• Diagramme und Trends\n\nSie können diese Statistiken als PDF oder Excel für Ihre Archive exportieren.'
      },
      q13: {
        question: 'Kann ich HugoQuiz auf dem Handy nutzen?',
        answer: 'Ja, HugoQuiz ist vollständig responsiv und funktioniert perfekt auf:\n• Smartphones (iOS und Android)\n• Tablets\n• Computern\n\nTeilnehmer können Quizze spielen und auf Funktionen von jedem Gerät mit einem modernen Webbrowser zugreifen. Keine App-Installation erforderlich!'
      },
      q14: {
        question: 'Wie kontaktiere ich den Support bei einem Problem?',
        answer: 'Mehrere Möglichkeiten, uns zu kontaktieren:\n• Live-Chat (Symbol unten rechts)\n• E-Mail: contact@hugoquiz.com\n• Online-Dokumentation und Tutorials\n\nUnser Team antwortet in der Regel innerhalb von 24 Stunden an Werktagen. Premium- und Business-Abonnenten erhalten Priority-Support.'
      },
      q15: {
        question: 'Kann ich HugoQuiz kostenlos testen, bevor ich ein Abo abschließe?',
        answer: 'Absolut! HugoQuiz bietet:\n• Einen dauerhaft kostenlosen Plan mit wesentlichen Funktionen\n• Eine 7-tägige kostenlose Testversion für kostenpflichtige Pläne\n• Keine Kreditkarte für den kostenlosen Plan erforderlich\n\nDie 7-tägige Testversion gibt Ihnen Zugang zu ALLEN Premium-Funktionen. Sie können während des Testzeitraums jederzeit ohne Kosten kündigen.'
      }
    },
    docs: {
      events: {
        title: 'Veranstaltungsmanagement',
        description: 'Erstellen und verwalten Sie vollständige Veranstaltungen mit allen notwendigen Funktionen.',
        guests: {
          title: 'Gästeliste',
          content: 'Verwalten Sie Ihre Gästeliste effizient:\n\n• Gäste manuell hinzufügen oder aus Excel/CSV importieren\n• Anwesenheitsbestätigungen (RSVP) in Echtzeit verfolgen\n• E-Mail-Einladungen mit personalisiertem QR-Code senden\n• Begleitpersonen und Kinder verwalten\n• Gäste kategorisieren (Familie, Freunde, Kollegen)\n• Die vollständige Liste jederzeit exportieren\n• Ernährungseinschränkungen und Allergien verfolgen'
        },
        gifts: {
          title: 'Geschenkeliste',
          content: 'Erstellen Sie eine gemeinschaftliche Geschenkeliste:\n\n• Geschenkideen mit Fotos und Links hinzufügen\n• Gäste können ein Geschenk reservieren (nur für sie sichtbar)\n• Duplikate mit dem Reservierungssystem vermeiden\n• Prioritäten und Kategorien festlegen\n• Sammelkassen für große Geschenke hinzufügen\n• Benachrichtigungen erhalten, wenn ein Geschenk reserviert wird\n• Einfach danken mit integrierter Nachverfolgung'
        },
        tables: {
          title: 'Tischverwaltung',
          content: 'Organisieren Sie Ihren Empfang perfekt:\n\n• Verschiedene Tischtypen erstellen (rund, rechteckig, Cocktail)\n• Anzahl der Plätze pro Tisch festlegen\n• Ihre Tische benennen (Nummern, Blumennamen, Städte...)\n• Gäste per Drag & Drop zuweisen\n• Verbleibende Plätze anzeigen\n• Personalisierte Tischkarten drucken\n• Last-Minute-Änderungen einfach verwalten'
        },
        qrcode: {
          title: 'QR-Scanner & Check-in',
          content: 'Vereinfachen Sie den Gästeempfang:\n\n• Jeder Gast erhält einen einzigartigen QR-Code\n• Schnell scannen mit jedem Smartphone\n• Sofortige visuelle und akustische Bestätigung\n• Ankunftsverfolgung in Echtzeit\n• Erkennung ungültiger oder bereits gescannter QR-Codes\n• Live-Anwesenheitsstatistiken\n• Mehrere Check-in-Stationen möglich'
        },
        seating: {
          title: 'Interaktiver Sitzplan',
          content: 'Visualisieren und optimieren Sie Ihren Raum:\n\n• Intuitiver Drag & Drop-Editor\n• Tische, Bühne, Tanzfläche, Buffet positionieren\n• Dekorative Elemente hinzufügen (Eingang, Bar, Photo Booth)\n• Elemente frei skalieren und ausrichten\n• Automatische Speicherung von Änderungen\n• Übersicht für große Räume\n• Export und Druck des finalen Plans'
        },
        guestbook: {
          title: 'Digitales Gästebuch',
          content: 'Sammeln Sie wertvolle Erinnerungen:\n\n• Elegante Oberfläche für Nachrichten\n• Foto- und Selfie-Uploads durch Gäste\n• Optionale Sprach- oder Videonachrichten\n• Inhaltsmoderation bei Bedarf\n• Reaktionen und Likes auf Nachrichten\n• PDF-Export im Erinnerungsalbum-Format\n• Zugänglich vor, während und nach der Veranstaltung'
        },
        stats: {
          title: 'Detaillierte Statistiken',
          content: 'Analysieren Sie Ihre Veranstaltung detailliert:\n\n• RSVP-Antwortrate mit zeitlicher Entwicklung\n• Anwesenheitsstatistiken am Tag\n• Fragebogen- und Quiz-Analyse\n• Gästebuch-Engagement\n• Visuelle und exportierbare Diagramme\n• Vergleich mit Ihren vorherigen Veranstaltungen\n• Key Performance Indicators (KPIs)'
        },
        planning: {
          title: 'Planung & Zeitachse',
          content: 'Organisieren Sie jedes Detail Ihrer Veranstaltung:\n\n• Erstellen Sie eine detaillierte Zeitachse\n• Setzen Sie Meilensteine und Fristen\n• Weisen Sie Verantwortliche für jede Aufgabe zu\n• Kalender- oder Listenansicht nach Wunsch\n• Automatische E-Mail-Erinnerungen\n• Gesamtfortschritt verfolgen\n• Mit Ihren Dienstleistern teilen'
        },
        program: {
          title: 'Veranstaltungsprogramm',
          content: 'Kommunizieren Sie den Ablauf an Ihre Gäste:\n\n• Erstellen Sie ein detailliertes Stundenprogramm\n• Fügen Sie Icons und Beschreibungen hinzu\n• Definieren Sie Orte für jede Aktivität\n• Programm über Einladung zugänglich\n• Echtzeit-Updates bei Änderungen\n• Optionale Push-Benachrichtigungen\n• Druckbare Version verfügbar'
        },
        menu: {
          title: 'Menü & Karte',
          content: 'Präsentieren Sie Ihr Menü elegant:\n\n• Erstellen Sie mehrere Menüs (Erwachsene, Kinder, vegetarisch)\n• Fügen Sie Vorspeisen, Hauptgerichte, Desserts, Getränke hinzu\n• Geben Sie Allergene und Herkunft an\n• Integrieren Sie Gerichtfotos\n• Menü für Gäste einsehbar\n• Verknüpfen Sie Auswahl mit RSVP-Fragebogen\n• PDF-Export zum Drucken'
        },
        tasks: {
          title: 'Aufgabenverwaltung',
          content: 'Vergessen Sie nichts für den großen Tag:\n\n• Erstellen Sie Aufgabenlisten nach Kategorie\n• Weisen Sie Verantwortliche zu\n• Setzen Sie Fristen\n• Verfolgen Sie den Fortschritt prozentual\n• Erhalten Sie automatische Erinnerungen\n• Haken Sie erledigte Aufgaben ab\n• Arbeiten Sie mit Ihrem Organisationsteam zusammen'
        }
      },
      quiz: {
        title: 'Interaktive Quizze',
        description: 'Beleben Sie Ihre Veranstaltungen mit lustigen und fesselnden Quizzen.',
        create: {
          title: 'Quiz-Erstellung',
          content: 'Erstellen Sie fesselnde Quizze in Minuten:\n\n• Intuitive Erstellungsoberfläche\n• Multiple-Choice, Wahr/Falsch, Freitextfragen\n• Bilder und Medien zu Fragen hinzufügen\n• Antwortzeit pro Frage festlegen\n• Punkte nach Schwierigkeit konfigurieren\n• Vorschau vor Veröffentlichung\n• Bestehende Quizze duplizieren und ändern'
        },
        live: {
          title: 'Live-Modus (Echtzeit)',
          content: 'Moderieren Sie ein Live-Quiz wie ein Profi:\n\n• Wartezimmer mit Hintergrundmusik\n• Spieler treten per Code oder QR-Code bei\n• Sie steuern das Fragetempo\n• Synchronisierte Anzeige auf allen Bildschirmen\n• Echtzeit-Rangliste zwischen den Fragen\n• Teilnehmerreaktionen und Emojis\n• Animiertes Podium mit Musik am Ende\n• Perfekt für Hochzeiten, Teambuildings, Partys'
        },
        async: {
          title: 'Asynchroner Modus',
          content: 'Lassen Sie Spieler in ihrem eigenen Tempo teilnehmen:\n\n• Teilen Sie einen einzigartigen Link\n• Jeder spielt, wann er möchte\n• Begrenzte oder unbegrenzte Zeit pro Frage\n• Punkte werden automatisch gesammelt\n• Rangliste wird kontinuierlich aktualisiert\n• Ideal für Schulungen, Wiederholung, Umfragen\n• Ergebnisse jederzeit einsehbar'
        },
        leaderboard: {
          title: 'Rangliste & Podium',
          content: 'Feiern Sie Gewinner mit Stil:\n\n• Echtzeit-Rangliste während des Quiz\n• Animiertes Podium mit visuellen Effekten\n• Anpassbare Siegesmusik\n• Anzeige von Punkten und Antwortzeiten\n• Vollständige Rangliste exportieren\n• Optionale Teilnahmezertifikate\n• Social-Media-Sharing'
        },
        stats: {
          title: 'Quiz-Statistiken',
          content: 'Analysieren Sie die Leistung im Detail:\n\n• Rate richtiger Antworten pro Frage\n• Durchschnittliche Antwortzeit\n• Schwierigste Fragen\n• Punkteentwicklung\n• Sitzungsvergleich\n• Verbesserungsbereiche identifizieren\n• Daten für tiefe Analyse exportieren'
        },
        music: {
          title: 'Musik & Sounds',
          content: 'Schaffen Sie eine immersive Atmosphäre:\n\n• Wartezimmer-Musik\n• Countdown-Sounds\n• Richtig/Falsch-Jingle\n• Spannungsmusik zwischen Fragen\n• Fanfare für das Podium\n• Integrierte lizenzfreie Musikbibliothek\n• Eigene Musik hochladen'
        },
        media: {
          title: 'Bilder & Medien',
          content: 'Bereichern Sie Ihre Fragen visuell:\n\n• Bilder zu Fragen hinzufügen\n• YouTube-Videos einbetten\n• "Erraten Sie das Bild"-Fragen\n• Wiederverwendbare Mediengalerie\n• Automatische Bildoptimierung\n• Unterstützung gängiger Formate (JPG, PNG, GIF)\n• Speicher je nach Plan inklusive'
        },
        settings: {
          title: 'Erweiterte Einstellungen',
          content: 'Passen Sie jeden Aspekt des Quiz an:\n\n• Maximale Teilnehmerzahl\n• Nachzügler zulassen oder nicht\n• Fragenreihenfolge mischen\n• Antwortreihenfolge mischen\n• Zwischenstände anzeigen oder verbergen\n• Dunkler oder heller Modus\n• Farbanpassung'
        }
      },
      questionnaire: {
        title: 'Intelligente Fragebögen',
        description: 'Sammeln Sie präzise Informationen mit flexiblen Formularen.',
        create: {
          title: 'Fragebogen-Erstellung',
          content: 'Gestalten Sie professionelle Fragebögen:\n\n• Intuitiver visueller Editor\n• Drag & Drop zum Neuordnen\n• Mehrere Abschnitte und Seiten\n• Benutzerdefinierte Beschreibung und Anweisungen\n• Echtzeit-Vorschau\n• Bestehende Fragebögen duplizieren\n• Fertige Vorlagen (RSVP, Zufriedenheit...)'
        },
        conditional: {
          title: 'Bedingte Fragen',
          content: 'Erstellen Sie intelligente, personalisierte Pfade:\n\n• Fragen basierend auf vorherigen Antworten anzeigen\n• Beispiel: "Wie viele Begleitpersonen?" nur wenn "Kommen Sie? = Ja"\n• Mehrere Bedingungen (UND/ODER)\n• Ganze Abschnitte überspringen\n• Verschiedene Pfade basierend auf Profil\n• Logik im Editor sichtbar\n• Verschiedene Szenarien einfach testen'
        },
        types: {
          title: 'Fragetypen',
          content: 'Wählen Sie das Format für jeden Bedarf:\n\n• Einzelauswahl (Radio)\n• Mehrfachauswahl (Checkboxen)\n• Kurzer oder langer Text\n• E-Mail, Telefon mit Validierung\n• Datum und Uhrzeit\n• Bewertungsskala (1-5, 1-10)\n• Datei-Upload\n• Rangfolge nach Präferenz'
        },
        results: {
          title: 'Ergebnisse & Analyse',
          content: 'Nutzen Sie Antworten effektiv:\n\n• Statistikübersicht\n• Diagramme pro Frage\n• Vollständiger Excel/CSV-Export\n• Filterung nach Kriterien\n• Detaillierte Einzelantworten\n• Zeitliche Entwicklung der Antworten\n• Automatische E-Mail-Berichte'
        },
        customization: {
          title: 'Anpassung',
          content: 'Passen Sie den Fragebogen an Ihre Marke an:\n\n• Benutzerdefiniertes Logo und Farben\n• Personalisierte Willkommensnachricht\n• Benutzerdefinierte Bestätigungsseite\n• Weiterleitung nach Einreichung\n• Anzahl der Antworten begrenzen\n• Automatisches Schließdatum\n• Optionaler Passwortschutz'
        }
      },
      account: {
        title: 'Mein Konto',
        description: 'Verwalten Sie Ihr Profil, Abonnement und Einstellungen.',
        subscription: {
          title: 'Abonnement & Abrechnung',
          content: 'Verwalten Sie Ihr Abonnement einfach:\n\n• Aktuellen Plan und seine Grenzen anzeigen\n• Plan jederzeit wechseln\n• Rechnungsverlauf\n• Zahlungsinformationen aktualisieren\n• Stornierung mit Rückerstattung innerhalb von 30 Min\n• 7-tägige kostenlose Testversion verfügbar\n• Priority-Support je nach Plan'
        },
        security: {
          title: 'Kontosicherheit',
          content: 'Schützen Sie Ihr Konto effektiv:\n\n• Passwortänderung\n• Anmeldeverlauf\n• Von allen Geräten abmelden\n• Konto und Daten löschen\n• DSGVO-Konformität garantiert\n• Alle Ihre Daten exportieren\n• Zwei-Faktor-Verifizierung (in Kürze)'
        },
        notifications: {
          title: 'Benachrichtigungen',
          content: 'Bleiben Sie informiert ohne überflutet zu werden:\n\n• Anpassbare E-Mail-Benachrichtigungen\n• Alerts für neue Antworten\n• Erinnerungen an bevorstehende Veranstaltungen\n• Aufgabenbenachrichtigungen\n• Optionale wöchentliche Zusammenfassung\n• In-App-Benachrichtigungszentrum\n• Selektive Deaktivierung möglich'
        },
        support: {
          title: 'Support & Hilfe',
          content: 'Wir sind hier, um zu helfen:\n\n• Live-Chat mit unserem Team\n• E-Mail-Support innerhalb von 24h\n• Vollständige Online-Dokumentation\n• Schritt-für-Schritt-Video-Tutorials\n• Regelmäßig aktualisierte FAQ\n• Priority-Support für Premium\n• Personalisierter Business-Support'
        }
      }
    },
    contact: {
      title: 'Brauchen Sie mehr Hilfe?',
      description: 'Unser Team steht bereit, um alle Ihre Fragen zu beantworten und Ihnen bei der Nutzung von HugoQuiz zu helfen.',
      email: 'Kontaktieren Sie uns per E-Mail'
    }
  },

  privacy: {
    title: 'Datenschutzerklärung',
    lastUpdated: 'Letzte Aktualisierung:',
    intro: {
      title: 'Datenschutz',
      description: 'Ihr Vertrauen ist uns wichtig. Diese Seite erklärt, wie wir Ihre personenbezogenen Daten bei der Nutzung unserer Website und Dienste erfassen, verwenden und schützen.'
    },
    section1: {
      title: '1. Verantwortlicher für die Datenverarbeitung',
      description: 'Der Verantwortliche für die Verarbeitung Ihrer personenbezogenen Daten ist:',
      website: 'Website:'
    },
    section2: {
      title: '2. Erhobene Daten',
      description: 'Wir erfassen verschiedene Arten von Daten, um unsere Dienste bereitzustellen:',
      email: {
        title: 'E-Mail-Adresse',
        description: 'Erforderlich zur Kontoerstellung und Kommunikation.'
      },
      username: {
        title: 'Benutzername',
        description: 'Öffentlicher Name, der bei Quiz und Ranglisten angezeigt wird.'
      },
      password: {
        title: 'Passwort',
        description: 'Sicher gespeichert mit Hashing-Algorithmen.'
      },
      payment: {
        title: 'Zahlungsinformationen',
        description: 'Werden sicher von Stripe verarbeitet, wir speichern Ihre Bankdaten nicht.'
      },
      connection: {
        title: 'Verbindungsdaten',
        description: 'IP-Adresse, Browsertyp, Zugriffszeiten für die Sicherheit.'
      },
      content: {
        title: 'Erstellte Inhalte',
        description: 'Quiz, Fragebögen, Veranstaltungen und Antworten.'
      }
    },
    section3: {
      title: '3. Ihre Rechte',
      description: 'Gemäß der DSGVO haben Sie folgende Rechte:',
      access: {
        title: 'Auskunftsrecht',
        description: 'Sie können eine Kopie Ihrer Daten anfordern.'
      },
      rectification: {
        title: 'Recht auf Berichtigung',
        description: 'Sie können unrichtige Daten korrigieren.'
      },
      erasure: {
        title: 'Recht auf Löschung',
        description: 'Sie können die Löschung Ihrer Daten beantragen.'
      },
      portability: {
        title: 'Recht auf Datenübertragbarkeit',
        description: 'Sie können Ihre Daten in einem strukturierten Format erhalten.'
      },
      restriction: {
        title: 'Recht auf Einschränkung der Verarbeitung',
        description: 'Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.'
      },
      objection: {
        title: 'Widerspruchsrecht',
        description: 'Sie können der Verarbeitung Ihrer Daten für bestimmte Zwecke widersprechen.'
      }
    },
    section4: {
      title: '4. Cookies und Tracking',
      description: 'Wir verwenden Cookies zur Verbesserung Ihrer Erfahrung:',
      essential: {
        title: 'Wesentliche Cookies',
        description: 'Erforderlich für das Funktionieren der Website (Authentifizierung, Einstellungen).'
      },
      analytics: {
        title: 'Analyse-Cookies',
        description: 'Helfen uns zu verstehen, wie die Website genutzt wird (anonymisiert).'
      },
      preferences: {
        title: 'Präferenz-Cookies',
        description: 'Speichern Ihre Präferenzen (Sprache, Theme).'
      }
    },
    section5: {
      title: '5. Datensicherheit',
      description: 'Wir implementieren robuste Sicherheitsmaßnahmen:',
      encryption: {
        title: 'Verschlüsselung',
        description: 'HTTPS-Verschlüsselung für alle Übertragungen.'
      },
      protection: {
        title: 'Schutz',
        description: 'Schutz vor CSRF, XSS und SQL-Injection-Angriffen.'
      },
      authentication: {
        title: 'Authentifizierung',
        description: 'Sichere Authentifizierung über Firebase.'
      },
      hosting: {
        title: 'Hosting',
        description: 'Daten werden in der EU auf sicheren Google Cloud-Servern gehostet.'
      }
    },
    section6: {
      title: '6. Datenaufbewahrung',
      description: 'Ihre Daten werden aufbewahrt:',
      active: {
        title: 'Aktives Konto',
        description: 'Solange Ihr Konto aktiv ist.'
      },
      deletion: {
        title: 'Nach Löschung',
        description: 'Daten werden nach einer Anfrage innerhalb von 30 Tagen gelöscht.'
      },
      backups: {
        title: 'Backups',
        description: 'Backups werden für maximal 90 Tage aufbewahrt.'
      }
    },
    section7: {
      title: '7. Datenweitergabe',
      description: 'Wir teilen Ihre Daten nur mit:',
      stripe: {
        title: 'Stripe',
        description: 'Für die sichere Zahlungsabwicklung.'
      },
      firebase: {
        title: 'Firebase/Google',
        description: 'Für Hosting und Authentifizierung.'
      },
      legal: {
        title: 'Gesetzliche Anforderungen',
        description: 'Bei gesetzlicher Verpflichtung.'
      }
    },
    section8: {
      title: '8. Kontakt',
      description: 'Bei Fragen zu Ihren Daten:',
      email: 'E-Mail:',
      response: 'Wir werden innerhalb von 30 Tagen auf jede Anfrage antworten.'
    }
  },

  cgu: {
    title: 'Allgemeine Nutzungsbedingungen',
    lastUpdated: 'Letzte Aktualisierung:',
    article1: {
      title: 'Artikel 1 - Gegenstand',
      p1: 'Diese Allgemeinen Nutzungsbedingungen (im Folgenden \"AGB\" genannt) regeln die Nutzung der Website HugoQuiz, die unter der Adresse hugoquiz.com erreichbar ist.',
      p2: 'Durch die Nutzung der Website erkennen Sie an, diese AGB vollständig gelesen und akzeptiert zu haben.'
    },
    article2: {
      title: 'Artikel 2 - Zugang zur Website',
      p1: 'Die Website ist für jede Person zugänglich, die über einen Internetzugang verfügt. Alle mit dem Zugang zur Website verbundenen Kosten, ob Hardware, Software oder Internetzugang, gehen ausschließlich zu Lasten des Nutzers.',
      p2: 'Der Zugang zu bestimmten Diensten erfordert die Erstellung eines Benutzerkontos. Der Nutzer verpflichtet sich, genaue Informationen anzugeben und diese aktuell zu halten.'
    },
    article3: {
      title: 'Artikel 3 - Geistiges Eigentum',
      p1: 'Alle Elemente der Website HugoQuiz (Texte, Bilder, Logos, Grafiken, Icons, Sounds, Software usw.) sind durch französische und internationale Gesetze zum geistigen Eigentum geschützt.',
      p2: 'Jede vollständige oder teilweise Vervielfältigung, Darstellung, Änderung, Veröffentlichung oder Anpassung der Elemente der Website ist ohne vorherige schriftliche Genehmigung des Eigentümers untersagt.'
    },
    article4: {
      title: 'Artikel 4 - Verantwortlichkeiten',
      p1: 'Der Herausgeber der Website HugoQuiz bemüht sich, soweit möglich, genaue und aktuelle Informationen bereitzustellen. Er kann jedoch nicht für Fehler, Auslassungen oder Ergebnisse aus der Nutzung dieser Informationen verantwortlich gemacht werden.',
      p2: 'Der Nutzer ist für die Nutzung der Website verantwortlich und verpflichtet sich, keinen rechtswidrigen Inhalt zu veröffentlichen oder zu verbreiten.'
    },
    article4bis: {
      title: 'ARTIKEL 4 BIS – KOSTENLOSE TESTVERSION',
      section1Title: '4 bis.1. BEDINGUNGEN DER KOSTENLOSEN TESTVERSION',
      section1Desc: 'Der Herausgeber bietet neuen Nutzern die Möglichkeit, eine kostenlose Testperiode von SIEBEN (7) TAGEN für jedes Monatsabonnement zu nutzen. Dieses Angebot unterliegt folgenden Bedingungen:',
      section1Item1: 'Die kostenlose Testversion ist nur EINMAL pro Nutzer verfügbar, unabhängig vom gewählten Tarif;',
      section1Item2: 'Wenn der Nutzer eine kostenlose Testversion für einen Tarif aktiviert, verliert er dauerhaft das Recht auf eine kostenlose Testversion für alle anderen Tarife;',
      section1Item3: 'Die Registrierung einer Zahlungsmethode (Kreditkarte) ist zur Aktivierung der kostenlosen Testversion erforderlich;',
      section1Item4: 'Nutzer, die einen kostenlosen Premium-Zugang vom Administrator erhalten haben, können die kostenlose Testversion nicht nutzen.',
      section2Title: '4 bis.2. DAUER UND FUNKTIONSWEISE',
      section2Desc: 'Während der siebentägigen (7) Testperiode:',
      section2Item1: 'Der Nutzer profitiert von allen Funktionen des gewählten Tarifs;',
      section2Item2: 'Während der Testperiode erfolgt keine Abbuchung;',
      section2Item3: 'Der Nutzer kann jederzeit vor Ende der Testperiode kostenlos kündigen.',
      section3Title: '4 bis.3. ENDE DER TESTPERIODE',
      section3Desc: 'Am Ende der siebentägigen (7) Testperiode:',
      section3Item1: 'Die erste Zahlung wird automatisch um 00:00 Uhr (Pariser Zeit) am achten (8.) Tag nach Aktivierung der Testversion abgebucht;',
      section3Item2: 'Das Abonnement wird dann gemäß den in Artikel 4.3 festgelegten Bedingungen automatisch verlängert;',
      section3Item3: 'Der Nutzer wird vor Ende der Testperiode per E-Mail benachrichtigt.',
      section4Title: '4 bis.4. KÜNDIGUNG WÄHREND DER TESTVERSION',
      section4Desc: 'Der Nutzer kann seine kostenlose Testversion jederzeit während der sieben (7) Tage über seinen persönlichen Bereich kündigen. Bei Kündigung während der Testperiode:',
      section4Item1: 'Es erfolgt keine Abbuchung;',
      section4Item2: 'Der Zugang zu Premium-Funktionen endet sofort;',
      section4Item3: 'Der Nutzer kann keine neue kostenlose Testversion mehr nutzen, auch nicht für einen anderen Tarif.',
      section5Title: '4 bis.5. MISSBRAUCHSSCHUTZ',
      section5Desc: 'Um Missbrauch zu verhindern, setzt der Herausgeber folgende Schutzmaßnahmen um:',
      section5Item1: 'Die Berechtigung für die kostenlose Testversion wird serverseitig überprüft und kann nicht umgangen werden;',
      section5Item2: 'Die Kündigung der kostenlosen Testversion ermöglicht nicht die Aktivierung einer neuen;',
      section5Item3: 'Der Herausgeber behält sich das Recht vor, eine kostenlose Testversion bei Verdacht auf Betrug abzulehnen oder zu stornieren.'
    },
    article5: {
      title: 'ARTIKEL 5 – WIDERRUFSRECHT, KÜNDIGUNG UND RÜCKERSTATTUNG',
      section1Title: '5.1. EINGESCHRÄNKTES WIDERRUFSRECHT',
      section1Desc: 'Gemäß den Bestimmungen des Verbraucherrechts und angesichts der Art der angebotenen Dienste (digitale Inhalte, die nicht auf einem materiellen Datenträger bereitgestellt werden und deren Ausführung mit der vorherigen ausdrücklichen Zustimmung des Verbrauchers begonnen hat) verfügt der Nutzer über ein eingeschränktes Widerrufsrecht unter den folgenden Bedingungen:',
      section1Important: 'Eine vollständige Rückerstattung des Abonnements ist nur möglich, wenn der Stornierungsantrag innerhalb von DREISSIG (30) MINUTEN nach dem ursprünglichen Abschluss des Abonnements gestellt wird. Nach Ablauf dieser Frist wird für den laufenden Abonnementzeitraum keine Rückerstattung gewährt.',
      section2Title: '5.2. KÜNDIGUNG DER VERLÄNGERUNG',
      section2Desc: 'Der Nutzer kann jederzeit und ohne jegliche Fristbeschränkung über seinen persönlichen Bereich entscheiden, sein Abonnement nicht zu verlängern:',
      section2Important: 'Die Kündigung der automatischen Verlängerung ist JEDERZEIT möglich, auch in den Stunden vor dem Verlängerungsdatum. Sobald die Kündigung erfolgt ist, erfolgt keine weitere Abbuchung und der Nutzer behält bis zum Ende des laufenden Abonnementzeitraums Zugang zu den Diensten. Es erfolgt keine Rückerstattung.',
      section3Title: '5.3. KEINE RÜCKERSTATTUNG',
      section3Desc: 'Der Nutzer behält das Recht, sein Abonnement jederzeit zu kündigen. Wenn die Kündigung jedoch erfolgt:',
      section3Item1: 'Mehr als dreißig (30) Minuten nach dem ursprünglichen Abschluss; oder',
      section3Item2: 'Nach Beginn eines bereits bezahlten Abonnementzeitraums; oder',
      section3Item3: 'Nach einer automatischen Verlängerung des Abonnements',
      section3NoRefund: 'Es wird keine Rückerstattung, auch keine teilweise oder anteilige, gewährt.',
      section4Title: '5.4. WICHTIGE HINWEISE',
      section4Desc: 'Das Widerrufsrecht mit Rückerstattung von dreißig (30) Minuten gilt ausschließlich für den ursprünglichen Abschluss eines Abonnements und nicht für nachfolgende automatische Verlängerungen.',
      section5Title: '5.5. SOFORTIGE KÜNDIGUNG DES TARIFS',
      section5Desc: 'Der Nutzer kann seinen Tarif jederzeit und ohne Einschränkung über seinen persönlichen Bereich sofort kündigen. In diesem Fall:',
      section5Item1: 'Der Verlust der Vorteile und Funktionen des Tarifs ist SOFORTIG;',
      section5Item2: 'Es ist keine Rückerstattung, auch keine teilweise, möglich;',
      section5Item3: 'Der Nutzer kehrt sofort zum kostenlosen Tarif zurück und erhält eine Bestätigung per E-Mail.'
    },
    article6: {
      title: 'Artikel 6 - Personenbezogene Daten',
      p1: 'Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung.',
      p2: 'Gemäß dem Datenschutzgesetz haben Sie ein Recht auf Zugang, Berichtigung und Löschung Ihrer personenbezogenen Daten.'
    },
    article7: {
      title: 'Artikel 7 - Cookies',
      p1: 'Die Website HugoQuiz verwendet Cookies, um Ihr Benutzererlebnis zu verbessern. Durch das weitere Surfen auf der Website stimmen Sie der Verwendung von Cookies zu.',
      p2: 'Sie können Ihren Browser so konfigurieren, dass Cookies abgelehnt werden, aber einige Funktionen der Website sind dann möglicherweise nicht verfügbar.'
    },
    article8: {
      title: 'Artikel 8 - Hyperlinks',
      p1: 'Die Website kann Hyperlinks zu anderen Websites enthalten. HugoQuiz übernimmt keine Verantwortung für den Inhalt dieser externen Websites.',
      p2: 'Das Erstellen von Hyperlinks zur Website HugoQuiz ist ohne vorherige Genehmigung gestattet, sofern es nicht den Interessen des Herausgebers schadet.'
    },
    article9: {
      title: 'Artikel 9 - AGB-Änderungen',
      p1: 'HugoQuiz behält sich das Recht vor, diese Allgemeinen Nutzungsbedingungen jederzeit zu ändern. Die fortgesetzte Nutzung der Website nach Änderungen gilt als Zustimmung zu den neuen Bedingungen.',
      p2: 'Nutzer werden über wesentliche Änderungen per E-Mail oder über eine Benachrichtigung auf der Website informiert.'
    },
    article10: {
      title: 'Artikel 10 - Anwendbares Recht',
      p1: 'Diese Allgemeinen Nutzungsbedingungen unterliegen französischem Recht. Bei Streitigkeiten sind die französischen Gerichte ausschließlich zuständig.',
      p2: 'Ist eine Bestimmung dieser AGB rechtswidrig, ungültig oder nicht durchsetzbar, bleiben die übrigen Bestimmungen in vollem Umfang gültig und wirksam.'
    },
    article10bis: {
      title: 'Artikel 10bis - Kontolöschung',
      section1: '10bis.1. Löschung auf Nutzerantrag',
      section1Desc: 'Jeder Nutzer kann jederzeit die Löschung seines Kontos über die Einstellungen anfordern.',
      section2: '10bis.2. Folgen der Löschung',
      section2Desc: 'Bei der Kontolöschung:',
      section2Items: 'Personenbezogene Daten werden innerhalb von 30 Tagen endgültig gelöscht. Erstellte Inhalte (Quiz, Fragebögen, Veranstaltungen) werden unwiderruflich gelöscht. Laufende Abonnements werden gekündigt, keine Rückerstattung bei Selbstlöschung.',
      section3: '10bis.3. Löschung durch Administration',
      section3Desc: 'HugoQuiz behält sich das Recht vor, Konten bei schwerwiegenden oder wiederholten Verstößen gegen diese AGB zu löschen.',
      section4: '10bis.4. Inaktivitätszeitraum',
      section4Desc: 'Nach 24 Monaten Inaktivität kann das Konto ohne Vorankündigung gelöscht werden.',
      section5: '10bis.5. Gelöschte Daten',
      section5Desc: 'Nach der Löschung sind folgende Daten unwiderruflich verloren:',
      section5Items: 'Quiz und Fragebögen. Veranstaltungen und Gästelisten. Punkte und Ranglisten. Zahlungshistorie (nur zusammenfassende Aufbewahrung für 10 Jahre). Leistungsstatistiken.',
      section6: '10bis.6. Datenbackup vor Löschung',
      section6Desc: 'Sie können einen vollständigen Export Ihrer Daten vor der Löschung anfordern. Diese Anfrage muss mindestens 15 Tage vor der Löschung des Kontos erfolgen.'
    },
    article11: {
      title: 'Artikel 11 - Verbotenes Verhalten',
      p1: 'Die Nutzer verpflichten sich:',
      items: 'Keine rechtswidrigen, verleumderischen, beleidigenden oder pornografischen Inhalte zu veröffentlichen. Die Website nicht für illegale Zwecke zu nutzen. Nicht zu versuchen, unbefugt auf die Systeme der Website zuzugreifen. Die Erfahrung anderer Nutzer nicht zu stören.',
      p2: 'Bei Verstoß gegen diese Regeln kann das Benutzerkonto unverzüglich gesperrt oder gekündigt werden.'
    },
    article12: {
      title: 'Artikel 12 - Kontakt',
      p1: 'Für alle Fragen zu diesen Allgemeinen Nutzungsbedingungen können Sie uns kontaktieren:',
      p2: 'Wir werden Ihre Anfragen schnellstmöglich beantworten.'
    },
    servicesSection: {
      title: 'Artikel 10 ter - Marktplatz „Services"',
      purposeTitle: 'Zweck',
      purpose: "HugoQuiz stellt einen Marktplatz bereit, auf dem Nutzer (die „Anbieter\") ihre Dienstleistungen anderen Nutzern oder Besuchern anbieten können. HugoQuiz handelt ausschließlich als technischer Vermittlungs-Host und ist nicht Vertragspartei der zwischen Anbietern und Kunden geschlossenen Verträge. Das Durchsuchen der Services ist frei; das Erstellen eines Service erfordert ein Konto und die vorherige Überprüfung der Identität des Anbieters.",
      verificationTitle: 'Identitätsprüfung',
      verification: "Um einen Service zu veröffentlichen, muss der Anbieter ein gültiges offizielles Ausweisdokument (Personalausweis, Reisepass der Europäischen Union, Aufenthaltstitel, Visum oder Führerschein) sowie ein kurzes Selfie-Video bereitstellen. Diese dienen ausschließlich dazu, zu bestätigen, dass die angegebene Identität mit der Person übereinstimmt. Jeder Service wird vor der Veröffentlichung von unserem Team geprüft.",
      prohibitedTitle: 'Verbotene Dienstleistungen',
      prohibitedIntro: 'Folgendes ist strengstens verboten und wird abgelehnt, eingeschränkt oder sofort entfernt, unbeschadet rechtlicher Schritte:',
      prohibited1: 'jeder Dienst sexueller, pornografischer oder Escort-Natur;',
      prohibited2: 'der Verkauf, die Herstellung oder der Vertrieb von Drogen, Betäubungsmitteln oder illegalen Substanzen;',
      prohibited3: 'der Verkauf von Waffen, Sprengstoffen oder regulierten gefährlichen Gütern;',
      prohibited4: 'jeder gesetzeswidrige oder in der Europäischen Union bzw. im Ausführungsland illegale Dienst;',
      prohibited5: 'Inhalte oder Aktivitäten, die zu Hass, Gewalt, Diskriminierung aufrufen oder die Rechte anderer verletzen;',
      prohibited6: 'jeglicher Betrug, jede Fälschung, Geldwäsche oder betrügerische Tätigkeit.',
      responsibilityTitle: 'Verantwortung der Anbieter',
      responsibility: "Der Anbieter ist allein verantwortlich für die Rechtmäßigkeit, Richtigkeit und Ausführung der von ihm angebotenen Dienste sowie für die Einhaltung seiner gesetzlichen, steuerlichen und behördlichen Pflichten. HugoQuiz behält sich das Recht vor, jeden Service zu moderieren, einzuschränken oder zu entfernen und jedes Konto zu sperren, falls gegen diese Bedingungen verstoßen wird, mit automatischer Benachrichtigung des betroffenen Nutzers.",
      dataTitle: 'Daten und Kontaktformular',
      data: "Öffentlich angezeigte Kontaktdaten (E-Mail, Telefon) werden nach Ermessen des Anbieters angezeigt. Wenn ein Besucher eine Anfrage über das Kontaktformular eines Service sendet, werden die von ihm bereitgestellten Informationen (Name, Telefon, Kundentyp, Betreff und Beschreibung der Anfrage) per Benachrichtigung und E-Mail an den betreffenden Anbieter weitergeleitet, um die Verbindung zu ermöglichen. Mit dem Absenden des Formulars stimmt der Nutzer dieser Verarbeitung und Übermittlung ausdrücklich zu. Ausweisdokumente und Verifizierungsvideos werden vertraulich behandelt und sind nur dem Moderationsteam von HugoQuiz zugänglich, gemäß der Datenschutzrichtlinie."
    }
  },

  auth: {
    email: 'E-Mail',
    emailPlaceholder: 'ihre@email.com',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    displayName: 'Anzeigename',
    displayNamePlaceholder: 'Max Mustermann',
    loginTitle: 'Anmelden',
    registerTitle: 'Konto erstellen',
    loginButton: 'Anmelden',
    registerButton: 'Registrieren',
    forgotPassword: 'Passwort vergessen?',
    forgotPasswordTitle: 'Passwort vergessen',
    resetPasswordDesc: 'E-Mail für Zurücksetzung eingeben',
    noAccount: 'Noch kein Konto?',
    hasAccount: 'Bereits ein Konto?',
    pendingValidation: 'Konto wartet auf Validierung',
    pendingMessage: 'Ihr Konto wird von einem Administrator überprüft.',
    backToHome: 'Zurück zur Startseite',
    backToLogin: 'Zurück zur Anmeldung',
    welcomeTo: 'Willkommen bei',
    joinHugoQuiz: 'HugoQuiz beitreten',
    createAccount: 'Mein Konto erstellen',
    sendResetLink: 'Link senden',
    passwordRequirements: {
      minLength: 'Mindestens 6 Zeichen',
      uppercase: 'Ein Großbuchstabe',
      number: 'Eine Zahl'
    },
    errors: {
      fillAllFields: 'Bitte füllen Sie alle Felder aus',
      fillAddressFields: 'Bitte füllen Sie alle Adressfelder aus',
      passwordMin6: 'Passwort muss mindestens 6 Zeichen haben',
      passwordNoMatch: 'Passwörter stimmen nicht überein',
      userNotFound: 'Kein Konto mit dieser E-Mail gefunden',
      wrongPassword: 'Falsches Passwort',
      invalidCredential: 'Ungültige E-Mail oder Passwort',
      connectionError: 'Verbindungsfehler',
      emailAlreadyUsed: 'Diese E-Mail wird bereits verwendet',
      invalidEmail: 'Ungültige E-Mail',
      invalidEmailFormat: 'Ungültiges E-Mail-Format',
      weakPassword: 'Passwort zu schwach',
      registerError: 'Fehler bei der Registrierung',
      enterEmail: 'Bitte geben Sie Ihre E-Mail ein',
      noAccountForEmail: 'Kein Konto mit dieser E-Mail verknüpft',
      tooManyAttempts: 'Zu viele Versuche. Versuchen Sie es später erneut.',
      resetError: 'Fehler beim Senden der Reset-E-Mail'
    },
    success: {
      loginSuccess: 'Anmeldung erfolgreich!',
      resetEmailSent: 'Reset-E-Mail gesendet! Überprüfen Sie Ihren Posteingang und Spam-Ordner.',
      verificationSent: 'Eine Bestätigungs-E-Mail wurde gesendet an'
    },
    passwordMismatch: 'Passwörter stimmen nicht überein',
    loginError: 'Ungültige E-Mail oder Passwort',
    emailInUse: 'Diese E-Mail wird bereits verwendet',
    invalidEmail: 'Ungültige E-Mail',
    weakPassword: 'Passwort zu schwach',
    verificationSent: 'Eine Bestätigungs-E-Mail wurde gesendet an',
    adminValidation: 'Nach der Registrierung muss Ihr Konto von einem Administrator validiert werden.',
    address: {
      title: 'Lieferadresse',
      street: 'Straße',
      streetNumber: 'Nummer',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      nameAtAddress: 'Name an der Adresse',
      nameAtAddressHint: 'Name, der bei Lieferungen erscheint',
      postalNotRecognized: 'Postleitzahl nicht erkannt, aber akzeptiert'
    }
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Willkommen',
    hello: 'Hallo',
    manageContent: 'Verwalten Sie Ihre Quiz und Fragebögen',
    myQuizzes: 'Meine Quiz',
    myQuestionnaires: 'Meine Fragebögen',
    myEvents: 'Meine Veranstaltungen',
    createQuiz: 'Quiz erstellen',
    createQuestionnaire: 'Fragebogen erstellen',
    createEvent: 'Veranstaltung erstellen',
    noQuizzes: 'Sie haben noch keine Quiz erstellt',
    noQuestionnaires: 'Sie haben noch keine Fragebögen erstellt',
    noEvents: 'Sie haben noch keine Veranstaltungen erstellt',
    noQuizzesDesc: 'Erstellen Sie Ihr erstes interaktives Quiz',
    noQuestionnairesDesc: 'Erstellen Sie Ihren ersten Fragebogen',
    noEventsDesc: 'Erstellen Sie Ihre erste Veranstaltung',
    createFirstQuiz: 'Mein erstes Quiz erstellen',
    createFirstQuestionnaire: 'Meinen ersten Fragebogen erstellen',
    createFirstEvent: 'Meine erste Veranstaltung erstellen',
    recentActivity: 'Letzte Aktivität',
    quickActions: 'Schnellaktionen',
    noDescription: 'Keine Beschreibung',
    dateNotSet: 'Datum nicht festgelegt',
    stats: {
      quizzesCreated: 'Erstellte Quiz',
      questionnaires: 'Fragebögen',
      events: 'Veranstaltungen',
      totalContent: 'Gesamtinhalt',
      totalQuizzes: 'Gesamt Quiz',
      totalQuestionnaires: 'Gesamt Fragebögen',
      totalEvents: 'Gesamt Veranstaltungen',
      totalResponses: 'Gesamt Antworten',
      totalParticipants: 'Gesamt Teilnehmer',
      totalGuests: 'Gesamt Gäste'
    },
    tabs: {
      quiz: 'Quiz',
      questionnaires: 'Fragebögen',
      events: 'Veranstaltungen',
      services: 'Services'
    },
    actions: {
      hostLive: 'Live moderieren',
      viewResponses: 'Antworten ansehen',
      share: 'Teilen',
      play: 'Spielen',
      answer: 'Antworten',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      manageGuests: 'Gäste verwalten',
      statistics: 'Statistiken',
      view: 'Ansehen'
    },
    actionPanel: {
      hostLive: 'Live starten',
      testQuiz: 'Quiz testen',
      viewResults: 'Ergebnisse ansehen',
      share: 'Teilen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      viewResponses: 'Antworten ansehen',
      test: 'Testen',
      guestList: 'Gästeliste',
      planning: 'Planung',
      tasks: 'Aufgaben',
      statistics: 'Statistiken',
      shareGiftList: 'Teilen',
      viewGiftList: 'Ansehen'
    },
    share: {
      title: 'Teilen',
      whatsapp: 'Auf WhatsApp teilen',
      email: 'Per E-Mail senden',
      copyLink: 'Link kopieren',
      linkCopied: 'Link kopiert!',
      copyError: 'Link konnte nicht kopiert werden',
      quizMessage: 'Spielen Sie mein Quiz',
      questionnaireMessage: 'Beantworten Sie meinen Fragebogen',
      eventMessage: 'Sehen Sie unsere Geschenkliste',
      quizEmailSubject: 'Quiz-Einladung',
      quizEmailBody: 'Hallo,\n\nIch lade Sie ein, mein Quiz "{title}" zu spielen!\n\nKlicken Sie auf den folgenden Link zum Starten:\n{link}\n\nViel Glück! 🎯',
      questionnaireEmailSubject: 'Fragebogen-Einladung',
      questionnaireEmailBody: 'Hallo,\n\nIch lade Sie ein, meinen Fragebogen "{title}" zu beantworten.\n\nKlicken Sie auf den folgenden Link zum Teilnehmen:\n{link}\n\nVielen Dank für Ihre Teilnahme! 📋',
      eventEmailSubject: 'Geschenkliste',
      eventEmailBody: 'Hallo,\n\nSie sind eingeladen, unsere Geschenkliste für "{title}" anzusehen!\n\nKlicken Sie auf den folgenden Link, um die Liste zu sehen und ein Geschenk zu reservieren:\n{link}\n\nVielen Dank! 🎁'
    },
    deleteModal: {
      title: 'Löschen bestätigen',
      message: 'Sind Sie sicher, dass Sie "{title}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      cancel: 'Abbrechen',
      confirm: 'Löschen',
      success: 'Erfolgreich gelöscht',
      error: 'Fehler beim Löschen'
    },
    eventTypes: {
      mariage: 'Hochzeit',
      anniversaire: 'Geburtstag',
      naissance: 'Geburt',
      bapteme: 'Taufe',
      cremaillere: 'Einweihungsparty',
      noel: 'Weihnachten',
      autre: 'Andere'
    },
    loading: 'Laden...',
    loadError: 'Fehler beim Laden der Daten'
  },
  quiz: {
    title: 'Quiz-Titel',
    description: 'Beschreibung',
    questions: 'Fragen',
    question: 'Frage',
    answers: 'Antworten',
    answer: 'Antwort',
    correctAnswer: 'Richtige Antwort',
    wrongAnswer: 'Falsche Antwort',
    timeLimit: 'Zeitlimit',
    timeLimitSeconds: 'Sekunden',
    points: 'Punkte',
    addQuestion: 'Frage hinzufügen',
    play: 'Quiz spielen',
    playLive: 'Live-Quiz',
    results: 'Ergebnisse',
    score: 'Punktzahl',
    leaderboard: 'Rangliste',
    yourAnswer: 'Ihre Antwort',
    correct: 'Richtig',
    incorrect: 'Falsch',
    timeUp: 'Zeit abgelaufen!',
    nextQuestion: 'Nächste Frage',
    finish: 'Beenden',
    true: 'Richtig',
    false: 'Falsch',
    // Play mode translations
    yourName: 'Ihr Name',
    enterNamePlaceholder: 'Geben Sie Ihren Namen ein...',
    prepareToPlay: 'Machen Sie sich bereit zu spielen!',
    loading: 'Quiz wird geladen...',
    checkAllCorrect: 'Kreuzen Sie alle richtigen Antworten an',
    validateAnswer: 'Meine Antwort bestätigen',
    selectAnswer: '-- Wählen Sie eine Antwort --',
    correctAnswerWas: 'Die richtige Antwort war',
    typeYourAnswer: 'Geben Sie Ihre Antwort ein...',
    enterNumber: 'Geben Sie eine Zahl ein...',
    validate: 'Bestätigen',
    selectAtLeastOne: 'Wählen Sie mindestens eine Antwort',
    enterAnswer: 'Geben Sie eine Antwort ein',
    enterValidNumber: 'Geben Sie eine gültige Zahl ein',
    selectRating: 'Wählen Sie eine Bewertung',
    puzzleReorder: 'In die richtige Reihenfolge bringen',
    puzzleInstruction: 'Verwenden Sie die Pfeile, um die Elemente neu anzuordnen',
    validateOrder: 'Meine Reihenfolge bestätigen',
    correctOrder: 'Richtige Reihenfolge',
    bravo: 'Gut gemacht',
    answerDetails: 'Antwortdetails',
    replay: 'Nochmal spielen',
    questionTypes: {
      singleChoice: 'Einzelauswahl',
      singleChoiceDesc: 'Eine Antwort möglich',
      multipleChoice: 'Mehrfachauswahl',
      multipleChoiceDesc: 'Mehrere Antworten möglich',
      trueFalse: 'Richtig oder Falsch',
      trueFalseDesc: 'Richtig oder Falsch Frage',
      dropdown: 'Dropdown-Liste',
      dropdownDesc: 'Auswahl aus einer Liste',
      shortText: 'Kurztext',
      shortTextDesc: 'Freie Kurzantwort',
      number: 'Numerische Antwort',
      numberDesc: 'Eine Zahl als Antwort',
      rating: 'Bewertung',
      ratingDesc: 'Bewertung auf einer Skala',
      puzzle: 'Reihenfolge',
      puzzleDesc: 'Elemente in Reihenfolge bringen'
    },
    create: {
      title: 'Quiz erstellen',
      editTitle: 'Quiz bearbeiten',
      editSubtitle: 'Fragen und Einstellungen bearbeiten',
      quizInfo: 'Quiz-Informationen',
      quizTitle: 'Quiz-Titel',
      quizTitlePlaceholder: 'Z.B.: Allgemeinwissen-Quiz',
      quizDescription: 'Beschreibung (optional)',
      quizDescriptionPlaceholder: 'Beschreiben Sie Ihr Quiz...',
      defaultTime: 'Standardzeit pro Frage',
      timeSeconds: 'Zeit (Sek)',
      isPublic: 'Öffentliches Quiz',
      isPublicDesc: 'Für alle Benutzer sichtbar',
      showAnswers: 'Antworten zeigen',
      shuffle: 'Mischen',
      addImage: 'Bild hinzufügen',
      questionText: 'Fragetext',
      questionTextPlaceholder: 'Geben Sie Ihre Frage ein...',
      noQuestionText: 'Frage ohne Text',
      questionImage: 'Fragenbild',
      imageTip: 'Das Bild wird den Spielern während der Frage angezeigt',
      questionType: 'Fragetyp',
      answerOptions: 'Antwortmöglichkeiten',
      answerPlaceholder: 'Antwort',
      addOption: 'Option hinzufügen',
      addAnswer: 'Antwort hinzufügen',
      addElement: 'Element hinzufügen',
      markCorrect: 'Als richtig markieren',
      puzzleElements: 'Zu ordnende Elemente',
      puzzleOrderHint: 'die hier angezeigte Reihenfolge = die richtige Reihenfolge',
      puzzleTip: 'Geben Sie die Elemente in der RICHTIGEN REIHENFOLGE ein. Spieler sehen sie gemischt und müssen sie in diese Reihenfolge bringen.',
      acceptedAnswers: 'Akzeptierte richtige Antworten',
      acceptedAnswersPlaceholder: 'Geben Sie akzeptierte Antworten durch Kommas getrennt ein...\nBeispiel: Paris, paris, PARIS',
      acceptedAnswersTip: 'Trennen Sie verschiedene akzeptierte Schreibweisen mit Kommas.',
      correctNumber: 'Richtige Antwort (genaue Zahl)',
      correctStars: 'Richtige Antwort (Anzahl Sterne)',
      questionDuration: 'Fragedauer',
      questionDuplicated: 'Frage dupliziert',
      maxOptions: 'Maximal 6 Optionen',
      minAnswers: 'Mindestens 2 Optionen erforderlich',
      minQuestions: 'Quiz muss mindestens eine Frage haben',
      titleRequired: 'Bitte geben Sie einen Quiz-Titel ein',
      questionTextRequired: 'Bitte geben Sie den Fragetext ein',
      minOptionsRequired: 'Mindestens 2 Optionen sind erforderlich',
      selectCorrect: 'Bitte wählen Sie mindestens eine richtige Antwort',
      correctAnswerRequired: 'Bitte geben Sie die richtige Antwort ein',
      updateSuccess: 'Quiz aktualisiert!',
      saveQuiz: 'Quiz speichern',
      saving: 'Wird gespeichert...',
      saveSuccess: 'Quiz erfolgreich gespeichert',
      saveError: 'Fehler beim Speichern'
    },
    live: {
      title: 'Live-Quiz',
      host: 'Moderieren',
      join: 'Beitreten',
      waitingRoom: 'Warteraum',
      waitingForHost: 'Warten auf Moderator...',
      waitingForPlayers: 'Warten auf Spieler...',
      startQuiz: 'Quiz starten',
      playersReady: 'Spieler bereit',
      enterName: 'Name eingeben',
      enterNamePlaceholder: 'Ihr Spitzname',
      joinGame: 'Spiel beitreten',
      shareLink: 'Link teilen',
      shareCode: 'oder dieser Code',
      scanQR: 'QR-Code scannen',
      preparing: 'Quiz wird vorbereitet...',
      getReady: 'Mach dich bereit!',
      questionOf: 'Frage {{current}} von {{total}}',
      showResults: 'Ergebnisse anzeigen',
      showLeaderboard: 'Rangliste anzeigen',
      showPodium: 'Podium anzeigen',
      nextQuestionBtn: 'Nächste Frage',
      endQuiz: 'Quiz beenden',
      stopQuiz: 'Quiz stoppen',
      forceStop: 'Erzwungenes Stoppen',
      quizEnded: 'Quiz beendet!',
      thanks: 'Danke fürs Mitmachen!',
      yourScore: 'Ihre Punktzahl',
      yourRank: 'Ihr Rang',
      backToHome: 'Zurück zur Startseite',
      noAnswer: 'Keine Antwort',
      answered: 'Beantwortet',
      waiting: 'Warten...',
      correctPlayers: 'richtige Antworten',
      avgTime: 'Durchschnittszeit',
      fastestPlayer: 'Schnellster',
      you: 'Sie',
      noScoresYet: 'Noch keine Punkte',
      playersCount: '{{count}} Spieler',
      playersCount_plural: '{{count}} Spieler',
      playersConnected: '{{count}} Spieler verbunden',
      playersConnected_plural: '{{count}} Spieler verbunden',
      playingAs: 'Sie spielen als',
      youAreFirst: 'Sie sind Erster!',
      hostAboutToStart: 'Der Moderator wird das Quiz bald starten',
      orderElements: 'Ordnen Sie die Elemente richtig',
      validateOrder: 'Meine Reihenfolge bestätigen',
      answerCount: '{{count}} Antwort',
      answerCount_plural: '{{count}} Antworten',
      checkAllCorrect: 'Kreuzen Sie alle richtigen Antworten an',
      validateAnswer: 'Meine Antwort bestätigen',
      typeYourAnswer: 'Ihre Antwort eingeben...',
      enterNumber: 'Zahl eingeben...',
      validate: 'Bestätigen',
      answerSent: 'Antwort gesendet!',
      waitingForTimeEnd: 'Warten auf Zeitende...',
      correctAnswerWas: 'Die richtige Antwort war',
      // New keys
      joinLiveQuiz: 'Live-Quiz beitreten',
      chooseAvatar: 'Wählen Sie Ihr Avatar',
      randomEmoji: 'Zufälliges Emoji',
      joinWaitingRoom: 'Warteraum beitreten',
      hostMode: 'MODERATOR-MODUS',
      players: 'Spieler',
      revealAnswers: 'Antworten aufdecken',
      answersReceived: 'Antworten erhalten',
      viewFinalScores: 'Endergebnisse anzeigen',
      finalScores: 'ENDERGEBNISSE',
      yourFinalRanking: 'Ihre Endplatzierung',
      sessionNotFound: 'Spielsitzung nicht gefunden',
      alreadyStarted: 'Dieses Quiz hat bereits begonnen',
      sessionClosed: 'Die Sitzung wurde geschlossen',
      welcome: 'Willkommen zum Quiz!',
      joinError: 'Fehler beim Beitreten',
      notFound: 'Quiz nicht gefunden',
      notOwner: 'Sie sind nicht der Eigentümer dieses Quiz',
      noQuestions: 'Dieses Quiz hat keine Fragen',
      loadError: 'Fehler beim Laden des Quiz',
      startError: 'Fehler beim Starten',
      nextQuestionError: 'Fehler beim Weiterschalten zur nächsten Frage',
      confirmStop: 'Sind Sie sicher, dass Sie das Quiz jetzt stoppen möchten?',
      correct: 'Richtig!',
      incorrect: 'Falsch',
      points: 'Punkte',
      podium: {
        title: 'Podium',
        first: '1.',
        second: '2.',
        third: '3.',
        congratulations: 'Herzlichen Glückwunsch!',
        bestPlayers: 'Die besten Spieler dieses Quiz!'
      }
    }
  },
  questionnaire: {
    title: 'Fragebogen-Titel',
    description: 'Beschreibung',
    questions: 'Fragen',
    question: 'Frage',
    create: 'Fragebogen erstellen',
    edit: 'Fragebogen bearbeiten',
    editDescription: 'Bearbeiten Sie die Fragen und Verzweigungsbedingungen',
    generalInfo: 'Allgemeine Informationen',
    descriptionOptional: 'Beschreibung (optional)',
    addQuestion: 'Frage hinzufügen',
    questionText: 'Fragetext',
    responseType: 'Antworttyp',
    responseOptions: 'Antwortoptionen',
    addOption: 'Option hinzufügen',
    placeholderLabel: 'Platzhalter (Hilfstext)',
    required: 'Pflichtfrage',
    requiredShort: 'Pflicht',
    conditional: 'Bedingt',
    conditionalBranching: 'Bedingte Frage (Verzweigung)',
    defineWhereToGo: 'Definieren Sie wohin je nach Antwort:',
    ifAnswer: 'Wenn "{{answer}}" →',
    nextQuestionDefault: 'Nächste Frage (Standard)',
    nextQuestion: 'Nächste Frage',
    byDefault: 'Standardmäßig →',
    endOfQuestionnaire: 'Ende des Fragebogens',
    noText: 'Ohne Text',
    questionWithoutText: 'Frage ohne Text',
    noQuestionsAdded: 'Keine Fragen hinzugefügt',
    addFirstQuestion: 'Erste Frage hinzufügen',
    notFound: 'Fragebogen nicht gefunden',
    noQuestions: 'Dieser Fragebogen hat keine Fragen',
    enterName: 'Bitte geben Sie Ihren Namen ein',
    startError: 'Fehler beim Starten',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail ein',
    selectAtLeastOne: 'Bitte wählen Sie mindestens eine Option',
    requiredQuestion: 'Diese Frage ist erforderlich',
    play: {
      title: 'Fragebogen',
      description: 'Beantworten Sie die folgenden Fragen',
      yourName: 'Ihr Name',
      enterName: 'Geben Sie Ihren Namen ein',
      start: 'Starten',
      questionOf: 'Frage {{current}} von {{total}}',
      multipleAnswersPossible: 'Mehrere Antworten möglich',
      selectOption: 'Option auswählen',
      yourAnswer: 'Ihre Antwort',
      yourDetailedAnswer: 'Ihre ausführliche Antwort',
      enterNumber: 'Geben Sie eine Zahl ein',
      previous: 'Vorherige',
      next: 'Weiter',
      finish: 'Beenden',
      thanks: 'Danke {{name}}!',
      responsesRecorded: 'Ihre Antworten wurden aufgezeichnet.',
      summary: 'Zusammenfassung',
      questionsAnswered: '{{count}} Frage(n) beantwortet',
      seeDetails: 'Details anzeigen',
      backToHome: 'Zurück zur Startseite'
    },
    responses: 'Antworten',
    totalResponses: 'erhaltene Antworten',
    noResponses: 'Noch keine Antworten',
    optional: 'Optionale Frage',
    conditionalLogic: 'Bedingte Logik',
    addCondition: 'Bedingung hinzufügen',
    thenGoTo: 'Dann gehe zu',
    questionTypes: {
      singleChoice: 'Einzelauswahl',
      multipleChoice: 'Mehrfachauswahl',
      trueFalse: 'Wahr/Falsch',
      dropdown: 'Dropdown',
      shortText: 'Kurztext',
      longText: 'Langtext',
      number: 'Zahl',
      email: 'E-Mail',
      date: 'Datum',
      rating: 'Bewertung',
      yesNo: 'Ja/Nein'
    },
    placeholders: {
      title: 'Z.B.: Zufriedenheitsumfrage',
      description: 'Beschreiben Sie kurz Ihren Fragebogen...',
      questionText: 'Geben Sie Ihre Frage ein...',
      option: 'Option',
      placeholder: 'Z.B.: Geben Sie Ihre Antwort ein...',
      shortText: 'Ihre Antwort...',
      longText: 'Schreiben Sie Ihre ausführliche Antwort...',
      number: 'Geben Sie eine Zahl ein',
      email: 'ihre@email.com',
      date: 'Wählen Sie ein Datum'
    },
    submit: 'Absenden',
    submitSuccess: 'Danke für Ihre Antwort!',
    submitError: 'Fehler beim Absenden',
    results: {
      title: 'Ergebnisse',
      summary: 'Zusammenfassung',
      details: 'Details',
      export: 'Exportieren',
      filter: 'Filtern',
      respondent: 'Befragter',
      date: 'Datum',
      viewResponse: 'Antwort anzeigen'
    },
    playScreen: {
      title: 'Fragebogen',
      description: 'Beschreibung',
      yourName: 'Ihr Name',
      enterName: 'Geben Sie Ihren Namen ein',
      start: 'Starten',
      questionOf: 'Frage {current} von {total}',
      multipleAnswersPossible: 'Mehrere Antworten möglich',
      selectOption: 'Option auswählen',
      yourAnswer: 'Ihre Antwort',
      yourDetailedAnswer: 'Ihre ausführliche Antwort',
      enterNumber: 'Geben Sie eine Zahl ein',
      previous: 'Vorherige',
      next: 'Weiter',
      finish: 'Beenden',
      thanks: 'Danke!',
      responsesRecorded: 'Ihre Antworten wurden aufgezeichnet.',
      summary: 'Zusammenfassung',
      questionsAnswered: 'Beantwortete Fragen',
      seeDetails: 'Details anzeigen',
      backToHome: 'Zurück zur Startseite'
    }
  },
  events: {
    event: 'Veranstaltung',
    ourEvent: 'unsere Veranstaltung',
    title: 'Veranstaltungstitel',
    date: 'Datum',
    location: 'Ort',
    guests: 'Gäste',
    guest: 'Gast',
    tables: 'Tische',
    table: 'Tisch',
    seatingPlan: 'Sitzplan',
    guestbook: 'Gästebuch',
    giftList: 'Geschenkliste',
    scanner: 'QR-Scanner',
    present: 'Anwesend',
    absent: 'Abwesend',
    addGuest: 'Gast hinzufügen',
    exportExcel: 'Excel exportieren',
    totalGuests: 'Gäste gesamt',
    create: {
      title: 'Veranstaltung erstellen',
      subtitle: 'Konfigurieren Sie Ihre Veranstaltung und Geschenkliste',
      editTitle: 'Veranstaltung bearbeiten',
      eventName: 'Veranstaltungsname',
      eventNamePlaceholder: 'Z.B.: Hochzeit von Sophie und Thomas',
      eventNameRequired: 'Veranstaltungsname ist erforderlich',
      eventDate: 'Veranstaltungsdatum',
      eventLocation: 'Ort',
      saveEvent: 'Veranstaltung speichern',
      other: 'Andere',
      basicInfo: 'Grundinformationen',
      basicInfoDesc: 'Name, Typ, Datum und Beschreibung',
      shortDescription: 'Kurze Beschreibung',
      shortDescriptionPlaceholder: 'Eine kurze Beschreibung Ihrer Veranstaltung...',
      coverImage: 'Titelbild',
      publicEvent: 'Öffentliche Veranstaltung',
      privateEvent: 'Private Veranstaltung',
      accessibleWithLink: 'Zugänglich mit Link',
      restrictedAccess: 'Eingeschränkter Zugang',
      publicEventWithLink: 'Öffentliche Veranstaltung (für alle mit Link zugänglich)',
      eventStory: 'Veranstaltungsgeschichte',
      eventStoryDesc: 'Erzählen Sie den Gästen Ihre Geschichte',
      storyHelpText: 'Teilen Sie die Geschichte Ihrer Veranstaltung. Erzählen Sie z.B. bei einer Hochzeit, wie Sie sich kennengelernt haben.',
      storyPlaceholder: 'Es war einmal...',
      invitationTicket: 'Einladungskarte',
      invitationTicketDesc: 'Personalisiertes Bild und Brief als PDF',
      howItWorks: 'So funktioniert es',
      invitationExplanation: 'Ihre Gäste können ein personalisiertes PDF mit Ihrem Einladungsbild + einem Brief mit ihrem Namen herunterladen.',
      invitationImage: 'Einladungsbild (PDF Seite 1)',
      invitationLetter: 'Einladungsbrief (PDF Seite 2)',
      invitationLetterHint: 'Das PDF beginnt mit "Liebe(r) [Gastname]," gefolgt von Ihrem Text.',
      invitationLetterPlaceholder: 'Wir freuen uns, Sie zu unserer Hochzeit einzuladen...',
      photoGallery: 'Fotogalerie',
      photoGalleryDesc: 'Automatische Fotomontage für Ihre Gäste',
      galleryHelpText: 'Fügen Sie bis zu 10 Fotos hinzu. Eine automatische Collage wird erstellt.',
      collagePreview: 'Collage-Vorschau',
      managePhotos: 'Fotos verwalten',
      createEvent: 'Veranstaltung erstellen',
      creating: 'Erstellen...',
      permissionDenied: 'Zugriff verweigert. Ihr Konto muss von einem Administrator validiert werden.',
      errorCreating: 'Fehler beim Erstellen: {{message}}',
      howItWorksTitle: 'So funktioniert es für Ihre Gäste',
      step1: 'Sie geben ihren vollständigen Namen ein',
      step2: 'Sie entdecken Ihre Geschichte und können ihre personalisierte Einladung herunterladen',
      step3: 'Sie greifen auf die Geschenkliste zu',
      showInvitationTicket: 'Einladungskarte anzeigen',
      showInvitationTicketDesc: 'Gäste können die Karte auf der Eventseite sehen und herunterladen',
      hideInvitationTicket: 'Einladungskarte ausblenden',
      hideInvitationTicketDesc: 'Die Karte wird für Gäste nicht sichtbar sein',
      backgroundMusic: 'Hintergrundmusik',
      backgroundMusicDesc: 'Musik wird auf der Foto- und Geschichtsseite in Schleife abgespielt',
      uploadMusic: 'Musik hochladen',
      musicFormats: 'Akzeptierte Formate: MP3, M4A, WAV, OGG (max 10 MB)',
      removeMusic: 'Musik entfernen',
      musicPlaying: 'Musik wird abgespielt',
      musicPaused: 'Musik pausiert'
    },
    edit: {
      notFound: 'Veranstaltung nicht gefunden',
      notAuthorized: 'Sie sind nicht berechtigt, diese Veranstaltung zu bearbeiten',
      loadError: 'Fehler beim Laden der Veranstaltung',
      updateSuccess: 'Veranstaltung erfolgreich aktualisiert',
      saveError: 'Fehler beim Speichern',
      deleteError: 'Fehler beim Löschen',
      reservationDeleted: 'Reservierung gelöscht',
      reservationDeleteError: 'Fehler beim Löschen der Reservierung',
      linkCopied: 'Link kopiert!',
      eventDetails: 'Veranstaltungsdetails',
      ourStory: 'Unsere Geschichte',
      configured: 'Konfiguriert',
      storyDesc: 'Erzählen Sie Ihre Geschichte! Besucher sehen sie vor der Geschenkliste.',
      storyPlaceholder: 'Wie habt ihr euch kennengelernt?',
      personalizedInvitation: 'Personalisierte Einladung',
      invitationDesc: 'Erstellen Sie eine personalisierte PDF-Einladung.',
      invitationImagePage1: 'Einladungsbild (PDF Seite 1)',
      formatRecommendation: 'Empfohlenes Format: A4 Hochformat (210x297mm)',
      letterTextPage2: 'Brieftext (PDF Seite 2)',
      letterPlaceholder: 'Lieber Gast,\n\nWir freuen uns sehr, Sie zu unserer Hochzeit einzuladen...',
      guestNameAutoAdded: 'Der Gastname wird automatisch oben im Brief hinzugefügt',
      galleryDesc: 'Fügen Sie bis zu 10 Fotos für eine automatische Collage hinzu.',
      saving: 'Speichern...',
      saveAllChanges: 'Alle Änderungen speichern',
      managePrograms: 'Programme & Menüs verwalten',
      reservation: 'Reservierung',
      deleteEventConfirmTitle: 'Veranstaltung löschen?',
      deleteEventConfirmMessage: 'Dies löscht auch alle zugehörigen Geschenke und Reservierungen. Diese Aktion ist unwiderruflich.',
      deleteReservationConfirmTitle: 'Diese Reservierung löschen?',
      deleteReservationConfirmMessage: 'Möchten Sie die Reservierung von {{name}} wirklich löschen?'
    },
    view: {
      event: 'Veranstaltung',
      notFound: 'Veranstaltung nicht gefunden',
      loadError: 'Fehler beim Laden der Veranstaltung',
      loadingEvent: 'Veranstaltung wird geladen...',
      oops: 'Hoppla!',
      backToHome: 'Zurück zur Startseite',
      welcome: 'Willkommen!',
      welcomeName: 'Willkommen {{name}}!',
      enterNameToAccess: 'Geben Sie Ihren Namen ein, um auf die Veranstaltung zuzugreifen',
      registerToAccess: 'Registrieren Sie sich, um auf die Veranstaltung und Geschenkliste zuzugreifen',
      yourFullName: 'Ihr vollständiger Name',
      enterFullName: 'Bitte geben Sie Ihren vollständigen Namen ein',
      fillNameRequired: 'Bitte füllen Sie Vor- und Nachnamen aus',
      selectRelation: 'Bitte wählen Sie Ihre Beziehung zum Veranstalter',
      fillSpouseRequired: 'Bitte füllen Sie die Partnerdaten aus',
      registrationError: 'Fehler bei der Registrierung',
      registrationNote: 'Ihre Registrierung wird vom Veranstalter validiert, bevor sie zur Gästeliste hinzugefügt wird.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      firstNamePlaceholder: 'Ihr Vorname',
      lastNamePlaceholder: 'Ihr Nachname',
      gender: 'Geschlecht',
      male: 'Mann',
      female: 'Frau',
      relationWithOrganizer: 'Beziehung zum Veranstalter',
      invitationType: 'Einladungsart',
      singleInvitation: 'Einzeleinladung',
      coupleInvitation: 'Paareinladung',
      spouseInfo: 'Partnerinformationen',
      spouseFirstName: 'Vorname des Partners',
      spouseLastName: 'Nachname des Partners',
      spouseGender: 'Geschlecht des Partners',
      toTheEvent: 'zur Veranstaltung',
      ourStory: 'Unsere Geschichte',
      yourPersonalizedInvitation: 'Ihre personalisierte Einladung',
      downloadPdfWithName: 'Laden Sie Ihre PDF-Einladung mit Ihrem Namen herunter',
      generating: 'Generieren...',
      downloadAgain: 'Erneut herunterladen',
      downloadMyInvitation: 'Meine Einladung herunterladen',
      invitationDownloadedSuccess: 'Einladung erfolgreich heruntergeladen!',
      pdfDownloaded: '🎉 Ihre personalisierte Einladung wurde heruntergeladen!',
      pdfError: 'Fehler beim Generieren des PDF',
      discoverGiftList: 'Geschenkliste entdecken',
      chooseGiftToOffer: 'Wählen Sie das Geschenk, das Sie schenken möchten',
      listEmpty: 'Die Liste ist noch leer',
      noGiftsYet: 'Der Organisator hat noch keine Geschenke hinzugefügt.',
      on: 'auf',
      reserveThisGift: 'Dieses Geschenk reservieren',
      yourName: 'Ihr Name',
      enterYourName: 'Bitte geben Sie Ihren Namen ein',
      stayAnonymous: 'Anonym bleiben',
      onlyOrganizerSees: 'Nur Sie und der Organisator sehen Ihren Namen; andere sehen „anonym“',
      you: 'Sie',
      anonymousSelfNote: 'Nur Sie und der Organisator sehen Ihren Namen. Andere sehen „anonym“.',
      howManyReserve: 'Wie viele möchten Sie reservieren?',
      outOf: 'von',
      available: 'verfügbar',
      messageOptional: 'Nachricht (optional)',
      messagePlaceholder: 'Eine kleine Nachricht für die Organisatoren... 💝',
      visibleToOrganizerOnly: 'Nur für den Organisator sichtbar',
      reserving: 'Reservieren...',
      onlyRemainingReservations: 'Nur noch {{count}} Reservierung(en) verfügbar',
      reservationSuccess: 'Danke {{name}}! 🎉 Ihre Reservierung wurde gespeichert.',
      reservationError: 'Fehler bei der Reservierung',
      linkCopied: '✨ Link in die Zwischenablage kopiert!',
      iOfferIt: 'Ich schenke das!',
      ourGallery: 'Unsere Galerie',
      photosAutoScroll: '{{count}} Foto(s) • Automatisch',
      photoOf: 'Foto {{current}} / {{total}}'
    },
    gifts: {
      title: 'Geschenkliste',
      gifts: 'Geschenke',
      gift: 'Geschenk',
      addGift: 'Geschenk hinzufügen',
      editGift: 'Geschenk bearbeiten',
      giftName: 'Geschenkname',
      giftNamePlaceholder: 'Z.B.: Küchenmaschine',
      giftNameRequired: 'Geschenkname ist erforderlich',
      giftPrice: 'Preis (€)',
      giftImage: 'Bild',
      giftLink: 'Externer Link',
      available: 'Verfügbar',
      reserved: 'Reserviert',
      purchased: 'Gekauft',
      reserveGift: 'Dieses Geschenk reservieren',
      reservedBy: 'Reserviert von',
      noGifts: 'Keine Geschenke in der Liste',
      addFirst: 'Fügen Sie Geschenke hinzu',
      giftUpdated: 'Geschenk aktualisiert',
      giftAdded: 'Geschenk hinzugefügt',
      giftDeleted: 'Geschenk gelöscht',
      giftSaveError: 'Fehler beim Speichern des Geschenks',
      deleteGiftConfirm: 'Dieses Geschenk löschen?',
      notesVisibleToGuests: 'Notizen (für Gäste sichtbar)',
      notesPlaceholder: 'Z.B.: Bevorzugte Farbe: rot',
      allowMultipleReservations: 'Mehrfache Reservierungen erlauben',
      giftType: 'Geschenktyp',
      typeArticle: 'Artikel',
      typeArticleDesc: 'Ein klassischer Artikel zum Verschenken',
      typeMoney: 'Geld',
      typeMoneyDesc: 'Freier finanzieller Beitrag',
      typeShared: 'Geteilter Artikel',
      typeSharedDesc: 'Artikel, dessen Preis unter mehreren Gästen geteilt wird',
      targetAmount: 'Zielbetrag (€)',
      targetAmountPlaceholder: 'Z.B.: 500',
      yourContribution: 'Ihr Beitrag (€)',
      contributionPlaceholder: 'Betrag eingeben',
      amountRequired: 'Bitte geben Sie einen Betrag ein',
      amountTooHigh: 'Betrag übersteigt den Restbetrag ({{remaining}}€)',
      contributionSuccess: 'Danke {{name}}! 🎉 Ihr Beitrag von {{amount}}€ wurde gespeichert.',
      contributionUpdated: 'Ihr Beitrag wurde aktualisiert.',
      yourPreviousContribution: 'Ihr vorheriger Beitrag',
      updateContribution: 'Meinen Beitrag ändern',
      remainingAmount: 'Restbetrag',
      goalReached: 'Ziel erreicht! 🎉',
      goalReachedDesc: 'Der Zielbetrag wurde erreicht',
      progressLabel: 'Fortschritt',
      contributorsCount: '{{count}} Beitragszahler',
      enterValidAmount: 'Bitte geben Sie einen gültigen Betrag ein',
      moneyGiftName: 'Finanzieller Beitrag',
      moneyGiftDesc: 'Gäste tragen den Betrag ihrer Wahl bei',
      privateContribution: 'Ihr Beitrag ist privat und nur für Sie und den Organisator sichtbar',
      sendMoney: 'Geld senden',
      paymentLink: 'Zahlungslink (Bank, PayPal, Lydia...)',
      paymentLinkDesc: 'Gäste können klicken, um Geld direkt zu senden',
      reservationsPossible: '{{count}} Reservierung(en) möglich',
      imageByUrl: 'Bild per URL',
      imageByUrlPlaceholder: 'https://beispiel.com/bild.jpg',
      imageByUpload: 'Bild hochladen',
      orUseUrl: 'Oder eine Bild-URL einfügen'
    }
  },
  guestbook: {
    title: 'Gästebuch',
    theGuestbook: 'Das Gästebuch',
    leaveMessage: 'Nachricht hinterlassen',
    leaveNote: 'Hinterlassen Sie eine Notiz',
    leaveNoteDesc: 'Teilen Sie Ihre Wünsche, eine Anekdote oder ein Foto-Erinnerung, um diesen Moment mit uns zu feiern.',
    leaveEternalMemory: 'Hinterlassen Sie eine ewige Erinnerung',
    leaveEternalMemoryDesc: 'Verewigen Sie Ihre Anwesenheit mit einer 3D-Nachricht für das Brautpaar.',
    yourName: 'Ihr Name',
    yourMessage: 'Ihre Nachricht',
    writeMemorable: 'Schreiben Sie etwas Unvergessliches...',
    characters: 'Zeichen',
    photoMemory: 'Foto-Erinnerung',
    photoFormats: 'JPG, PNG (max 5MB)',
    addPhoto: 'Foto hinzufügen',
    send: 'Senden',
    sign: 'Unterschreiben',
    signBook: 'Gästebuch unterschreiben',
    signTheBook: 'Buch unterschreiben',
    readBook: 'Buch lesen',
    messages: 'Nachrichten',
    noMessages: 'Noch keine Nachrichten',
    noMessagesYet: 'Noch keine Nachrichten...',
    beFirst: 'Seien Sie der Erste, der unterschreibt!',
    deleteMessage: 'Diese Nachricht löschen',
    deleteConfirm: 'Sind Sie sicher, dass Sie diese Nachricht löschen möchten?',
    messageDeleted: 'Nachricht gelöscht',
    from: 'Von:',
    withLove: '– Mit all unserer Liebe ❤️',
    memories: 'Erinnerungen...',
    pageOf: 'SEITE {{current}} VON {{total}}',
    latestMessages: 'Neueste Nachrichten',
    photoShared: '📷 Foto geteilt',
    experience3d: '3D-Erlebnis',
    howItWorks: 'Wie funktioniert es?',
    takePhoto: 'Machen Sie ein Foto',
    writeWord: 'Schreiben Sie eine Notiz',
    imageTooLarge: 'Bild zu groß (max 5 MB)',
    invalidFile: 'Ungültige Datei',
    enterName: 'Bitte geben Sie Ihren Namen ein',
    addMessageOrPhoto: 'Fügen Sie eine Nachricht oder ein Foto hinzu',
    messageAdded: 'Nachricht hinzugefügt! 💕',
    sendError: 'Fehler beim Senden',
    minutesAgo: 'Vor {{count}} Min',
    hoursAgo: 'Vor {{count}}h',
    daysAgo: 'Vor {{count}}T',
    noMessagesToExport: 'Keine Nachrichten zum Exportieren',
    generatingPdf: 'PDF wird generiert...',
    generatedOn: 'Generiert am',
    messagesCount: 'Nachricht(en)',
    pdfDownloaded: 'PDF heruntergeladen!',
    pdfError: 'Fehler beim Generieren des PDF',
    shareLink: 'Link teilen',
    downloadPdf: 'PDF herunterladen',
    linkShared: 'Link geteilt!',
    linkCopied: 'Link in Zwischenablage kopiert!',
    copyError: 'Link konnte nicht kopiert werden',
    shareText: 'Hinterlassen Sie eine Nachricht im Gästebuch von {{eventName}}! 💌',
    anonymous: 'Anonym',
    messagesPublic: 'Nachrichten für alle sichtbar',
    messagesPrivate: 'Nachrichten nur für Sie sichtbar',
    messagesPublicDesc: 'Gäste können die Nachrichten anderer lesen',
    messagesPrivateDesc: 'Gäste können nur schreiben, nur Sie können lesen'
  },

  // Guests
  guests: {
    title: 'Gästeliste',
    addGuest: 'Gast hinzufügen',
    editGuest: 'Gast bearbeiten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    gender: 'Geschlecht',
    male: 'Mann',
    female: 'Frau',
    ticketType: 'Tickettyp',
    single: 'Einzeln',
    couple: 'Paar',
    spouseInfo: 'Partnerinformationen',
    relation: 'Beziehung zum Organisator',
    selectRelation: '-- Auswählen --',
    table: 'Tisch',
    tableOptional: 'Tisch (optional)',
    notAssigned: '-- Nicht zugewiesen --',
    cancel: 'Abbrechen',
    addTheGuest: 'Gast hinzufügen',
    saveChanges: 'Speichern',
    totalGuests: 'Gäste insgesamt',
    tickets: 'Tickets',
    present: 'Anwesend',
    absent: 'Abwesend',
    presents: 'Anwesend',
    absents: 'Abwesend',
    searchGuest: 'Gast suchen...',
    allStatuses: 'Alle Status',
    allTickets: 'Alle Tickets',
    noGuests: 'Noch keine Gäste',
    noMatchingGuests: 'Kein Gast entspricht Ihrer Suche',
    addFirstGuest: 'Ersten Gast hinzufügen',
    guest: 'Gast',
    type: 'Typ',
    statusClick: 'Status (zum Ändern klicken)',
    actions: 'Aktionen',
    downloadPdf: 'PDF herunterladen',
    edit: 'Bearbeiten',
    deleteGuest: 'Löschen',
    yourInvitation: 'Ihre Einladungskarte',
    coupleTicket: 'Paar-Ticket mit',
    scanQrCode: 'Scannen Sie diesen QR-Code am Eingang',
    personalTicket: 'Dieses Ticket ist persönlich und nicht übertragbar',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortFirstNameAsc: 'Vorname (A → Z)',
    sortFirstNameDesc: 'Vorname (Z → A)',
    sortDateRecent: 'Neueste',
    sortDateOldest: 'Älteste',
    sortByTable: 'Nach Tisch',
    sortByRelation: 'Nach Beziehung',
    sortPresentFirst: 'Anwesende zuerst',
    sortAbsentFirst: 'Abwesende zuerst',
    tables: 'Tische',
    scanner: 'Scanner',
    plan: 'Plan',
    guestbook: 'Gästebuch',
    excel: 'Excel',
    add: 'Hinzufügen',
    // Excel export fields
    number: 'Nr.',
    arrivalDate: 'Ankunftsdatum',
    registrationDate: 'Registrierungsdatum',
    spouseFirstName: 'Vorname Partner',
    spouseLastName: 'Nachname Partner',
    spouseGender: 'Geschlecht Partner',
    spouseStatus: 'Status Partner',
    spouseArrival: 'Ankunft Partner',
    // Summary sheet
    statistic: 'Statistik',
    value: 'Wert',
    summary: 'Zusammenfassung',
    totalInvitations: 'Einladungen gesamt',
    totalPersons: 'Personen gesamt',
    guestsPresent: 'Gäste anwesend',
    guestsAbsent: 'Gäste abwesend',
    couples: 'Paare',
    singles: 'Einzelpersonen',
    spousesPresent: 'Partner anwesend',
    exportDate: 'Export-Datum',
    // Pending guests
    pendingApproval: 'Ausstehend',
    pendingRequests: 'Ausstehende Anfragen',
    confirmedList: 'Bestätigte Liste',
    noPendingRequests: 'Keine ausstehenden Anfragen',
    noPendingDescription: 'Gäste, die sich über den Event-Link registrieren, erscheinen hier zur Validierung.',
    pendingInfo: 'Diese Personen haben sich über den Event-Link registriert und warten auf Ihre Bestätigung.',
    requestedOn: 'Angefragt am',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    pendingApproved: 'Gast genehmigt und zur Liste hinzugefügt',
    pendingRejected: 'Anfrage abgelehnt',
    approveError: 'Fehler bei der Genehmigung',
    rejectError: 'Fehler bei der Ablehnung'
  },

  // Relations
  relations: {
    fatherGroom: 'Vater des Bräutigams',
    motherGroom: 'Mutter des Bräutigams',
    brotherGroom: 'Bruder des Bräutigams',
    sisterGroom: 'Schwester des Bräutigams',
    fatherBride: 'Vater der Braut',
    motherBride: 'Mutter der Braut',
    brotherBride: 'Bruder der Braut',
    sisterBride: 'Schwester der Braut',
    grandparent: 'Großeltern',
    uncle: 'Onkel',
    aunt: 'Tante',
    cousin: 'Cousin/Cousine',
    nephew: 'Neffe/Nichte',
    childhoodFriend: 'Kindheitsfreund(in)',
    closeFriend: 'Enger Freund(in)',
    colleague: 'Kollege/Kollegin',
    neighbor: 'Nachbar(in)',
    witness: 'Trauzeuge/Trauzeugin',
    bridesmaid: 'Brautjungfer',
    groomsman: 'Trauzeuge',
    otherFamily: 'Andere Familie',
    otherFriend: 'Anderer Freund',
    professional: 'Beruflich',
    other: 'Andere'
  },

  // Event Types
  eventTypes: {
    wedding: 'Hochzeit',
    birthday: 'Geburtstag',
    birth: 'Geburt',
    baptism: 'Taufe',
    housewarming: 'Einweihungsfeier',
    christmas: 'Weihnachten',
    other: 'Veranstaltung'
  },

  // Event Responses / Statistics
  eventResponses: {
    title: 'Statistiken',
    backToDashboard: 'Zurück zum Dashboard',
    stats: {
      giftsReserved: 'Reservierte Geschenke',
      participants: 'Teilnehmer',
      reservations: 'Reservierungen',
      reservedValue: 'Reservierter Wert'
    },
    progress: 'Fortschritt',
    reservationsList: 'Reservierungsliste',
    giftSummary: 'Geschenkübersicht',
    anonymous: 'anonym',
    giftDeleted: 'Geschenk gelöscht',
    deleteReservation: 'Reservierung löschen',
    noReservations: 'Noch keine Reservierungen',
    shareToReceive: 'Teilen Sie Ihre Liste, um Reservierungen zu erhalten',
    reservation: 'Reservierung',
    notReserved: 'Nicht reserviert',
    reserved: 'Reserviert',
    available: 'Verfügbar',
    confirmDelete: 'Diese Reservierung löschen?',
    deleteSuccess: 'Reservierung gelöscht',
    errors: {
      notFound: 'Veranstaltung nicht gefunden',
      unauthorized: 'Sie sind nicht berechtigt, diese Statistiken anzuzeigen',
      loadError: 'Fehler beim Laden der Daten',
      deleteError: 'Fehler beim Löschen'
    }
  },

  // Profile
  profile: {
    title: 'Mein Profil',
    subtitle: 'Verwalten Sie Ihre persönlichen Informationen',
    personalInfo: 'Persönliche Informationen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    bio: 'Biografie',
    bioPlaceholder: 'Erzählen Sie uns von sich...',
    address: 'Adresse',
    streetName: 'Straße',
    streetNumber: 'Nr.',
    postalCode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',
    photoUpdated: 'Profilbild aktualisiert',
    photoError: 'Fehler beim Hochladen des Fotos',
    photoDeleted: 'Profilbild gelöscht',
    deletePhoto: 'Löschen',
    deletePhotoError: 'Fehler beim Löschen des Fotos',
    invalidImageType: 'Bitte wählen Sie ein Bild aus',
    imageTooLarge: 'Das Bild darf 5MB nicht überschreiten',
    updated: 'Profil erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren des Profils',
    upgradeToPro: 'Auf Pro upgraden',
    managePlan: 'Mein Abonnement verwalten',
    unlockFeatures: 'Alle Funktionen und unbegrenzte Teilnehmer freischalten',
    currentPlan: 'Ihr aktueller Tarif: {{plan}}',
    renewsIn: 'Verlängerung in {{days}} Tagen',
    endsIn: 'Endet in {{days}} Tagen',
    manageSubscription: 'Verwalten / Kündigen',
    seePlans: 'Tarife ansehen',
    changePlan: 'Ändern',
    subscriptionSettings: 'Abonnement-Einstellungen',
    managePayments: 'Zahlungen und Rechnungen verwalten',
    viewPlans: 'Tarife ansehen',
    comparePlans: 'Verfügbare Angebote vergleichen',
    logoutDesc: 'Von Ihrem Konto abmelden',
    legalInfo: 'Rechtliche Informationen',
    dangerZone: 'Gefahrenzone',
    deleteAccountWarning: 'Die Kontolöschung ist unwiderruflich. Alle Ihre Daten werden dauerhaft gelöscht.',
    deleteAccount: 'Mein Konto löschen',
    confirmDeletion: 'Löschung bestätigen',
    actionIrreversible: 'Diese Aktion ist unwiderruflich',
    importantNotice: 'Wichtiger Hinweis',
    deleteWarning1: 'Alle Ihre Quizze, Fragebögen und Veranstaltungen werden gelöscht',
    deleteWarning2: 'Ihre persönlichen Daten werden dauerhaft gelöscht',
    deleteWarning3: 'Sie können nicht mehr auf Ihr Konto zugreifen',
    deleteWarning4: 'Wenn Ihr Abonnement in weniger als 48 Stunden verlängert wird und Sie die Verlängerung nicht gekündigt haben, wird die letzte Abbuchung vor der Löschung durchgeführt.',
    typeConfirm: 'Geben Sie "LÖSCHEN" zur Bestätigung ein:',
    typeSupprimer: 'Bitte geben Sie "LÖSCHEN" zur Bestätigung ein',
    accountMarkedDeleted: 'Konto zur Löschung markiert. Die letzte Abbuchung wird durchgeführt.',
    accountDeleted: 'Konto erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen des Kontos',
    confirmDelete: 'Dauerhaft löschen',
    adminGrantedAccess: 'Zugang vom Administrator gewährt',
    adminGrantedAccessDesc: 'Sie haben vollen Zugang vom Administrator gewährt bekommen.',
    revokeAccess: 'Diesen Zugang widerrufen',
    revokeAccessConfirm: 'Meinen Zugang widerrufen',
    revokeAccessDesc: 'Diese Aktion entfernt Ihren gewährten Zugang. Sie kehren zum kostenlosen Tarif zurück.'
  },

  settings: {
    title: 'Kontoeinstellungen',
    description: 'Verwalten Sie Ihre persönlichen Informationen',
    profile: 'Profil',
    language: 'Sprache',
    theme: 'Design',
    notifications: 'Benachrichtigungen',
    security: 'Sicherheit',
    changePassword: 'Passwort ändern',
    deleteAccount: 'Konto löschen',
    currentInfo: 'Aktuelle Informationen',
    displayName: 'Anzeigename',
    currentEmail: 'Aktuelle E-Mail',
    notDefined: 'Nicht definiert',
    preferences: 'Einstellungen',
    tutorial: 'Tutorial',
    restartTutorial: 'Tutorial neu starten',
    saveChanges: 'Änderungen speichern',
    email: {
      changeEmail: 'E-Mail ändern',
      newEmail: 'Neue E-Mail',
      confirmNewEmail: 'Neue E-Mail bestätigen',
      currentPassword: 'Aktuelles Passwort (zur Bestätigung)',
      passwordHelp: 'Geben Sie Ihr aktuelles Passwort ein, um die Änderung zu bestätigen',
      updateEmail: 'E-Mail aktualisieren',
      updating: 'Aktualisierung...',
      fillAllFields: 'Bitte füllen Sie alle Felder aus',
      emailsMismatch: 'E-Mails stimmen nicht überein',
      sameEmail: 'Die neue E-Mail ist identisch mit der aktuellen',
      invalidFormat: 'Ungültiges E-Mail-Format',
      verificationSent: '📧 Eine Bestätigungs-E-Mail wurde an {{email}} gesendet. Klicken Sie auf den Link, um die Änderung zu bestätigen.',
      verificationSentTitle: 'Bestätigungs-E-Mail gesendet!',
      verificationSentDesc: 'Überprüfen Sie Ihren Posteingang und klicken Sie auf den Link zur Bestätigung',
      wrongPassword: 'Falsches Passwort',
      emailInUse: 'Diese E-Mail wird bereits von einem anderen Konto verwendet',
      sessionExpired: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
      operationNotAllowed: 'Vorgang nicht erlaubt. Überprüfen Sie die Firebase-Einstellungen.',
      updateError: 'Fehler bei der Aktualisierung',
      howItWorks: 'Wie funktioniert es?',
      step1: '1. Geben Sie Ihre neue E-Mail und Ihr aktuelles Passwort ein',
      step2: '2. Eine Bestätigungs-E-Mail wird an die neue Adresse gesendet',
      step3: '3. Klicken Sie auf den Link in der E-Mail, um die Änderung zu bestätigen',
      important: 'Wichtig',
      importantDesc: 'Wenn Sie Ihre E-Mail ändern, ändert sich die Kennung, die Sie zum Anmelden verwenden. Sie müssen bei Ihrer nächsten Anmeldung die neue E-Mail verwenden.'
    }
  },
  admin: {
    title: 'Administration',
    tabs: {
      services: 'Services',
      messaging: 'Nachrichten'
    },
    messaging: {
      title: 'Nachricht senden',
      subtitle: 'Schreiben Sie an einen, mehrere oder alle Benutzer. Die Nachricht wird per E-Mail und Benachrichtigung zugestellt.',
      allUsers: 'Alle Benutzer',
      selectUsers: 'Benutzer auswählen',
      searchUser: 'Benutzer suchen...',
      toggleAll: 'Alle aus-/abwählen',
      noUsers: 'Kein Benutzer',
      subject: 'Betreff',
      subjectPlaceholder: 'Betreff Ihrer Nachricht',
      message: 'Nachricht',
      messagePlaceholder: 'Schreiben Sie hier Ihre Nachricht...',
      emailHint: 'Die E-Mail wird im HugoQuiz-Design mit einer Schaltfläche zur Website gestaltet.',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      needSubject: 'Bitte geben Sie einen Betreff ein.',
      needMessage: 'Bitte geben Sie eine Nachricht ein.',
      needRecipients: 'Wählen Sie mindestens einen Empfänger aus.',
      confirm: 'Diese Nachricht an {{count}} Benutzer senden?',
      sent: 'Nachricht an {{sent}}/{{total}} Benutzer gesendet.'
    },
    services: {
      verifications: 'Verifizierungen',
      servicesList: 'Services',
      reviews: 'Bewertungen',
      noReviews: 'Keine Bewertungen zur Freigabe.',
      reviewApproved: 'Bewertung veröffentlicht',
      reviewRejected: 'Bewertung abgelehnt',
      noVerifications: 'Keine ausstehenden Verifizierungsanfragen.',
      noServices: 'Keine Services.',
      idDocument: 'Ausweisdokument',
      openPdf: 'PDF öffnen',
      selfieVideo: 'Selfie-Video',
      approve: 'Bestätigen',
      reject: 'Ablehnen',
      publish: 'Veröffentlichen',
      restrict: 'Einschränken',
      preview: 'Ansehen',
      verifApproved: 'Identität bestätigt',
      verifRejected: 'Anfrage abgelehnt',
      serviceApproved: 'Service veröffentlicht',
      serviceUpdated: 'Service aktualisiert',
      serviceDeleted: 'Service gelöscht',
      messagePlaceholder: 'Nachricht mit Begründung (an den Benutzer gesendet)',
      statusPending: 'Ausstehend',
      statusApproved: 'Veröffentlicht',
      statusRejected: 'Abgelehnt',
      statusRestricted: 'Eingeschränkt',
      seedHint: 'Erstellen Sie zwei Demo-Services (Hugographie — Fotograf/Videograf und Hugo — Event-Planer), die mit Ihrem Admin-Konto verknüpft sind.',
      seedButton: 'Demo-Services erstellen',
      seedConfirm: 'Die Demo-Services Hugographie und Hugo auf Ihrem Admin-Konto erstellen?',
      seedDone: 'Demo-Services erstellt und veröffentlicht!',
      rejectVerifTitle: 'Verifizierungsanfrage ablehnen',
      rejectServiceTitle: 'Diesen Service ablehnen',
      restrictTitle: 'Anzeige dieses Service einschränken',
      deleteTitle: 'Diesen Service endgültig löschen',
      filter: { all: 'Alle', pending: 'Ausstehend', approved: 'Veröffentlicht', rejected: 'Abgelehnt', restricted: 'Eingeschränkt' }
    },
    users: 'Benutzer',
    userManagement: 'Benutzerverwaltung',
    pendingUsers: 'Ausstehende Benutzer',
    validatedUsers: 'Validierte Benutzer',
    validateUser: 'Benutzer validieren',
    deleteUser: 'Benutzer löschen',
    quizMusic: {
      title: 'Quiz-Musik',
      description: 'Musik während des Quiz verwalten',
      lobby: 'Wartemusik',
      effects: 'Soundeffekte',
      gameplay: 'Spielmusik',
      upload: 'Hochladen',
      delete: 'Löschen',
      play: 'Abspielen',
      noMusic: 'Keine Musik'
    },
    chat: {
      title: 'Chat-Verwaltung',
      subtitle: 'Antworten Sie wartenden Benutzern',
      description: 'Antworten Sie Benutzern, die menschliche Hilfe benötigen.',
      manage: 'Chats verwalten',
      waiting: 'Wartend',
      active: 'Aktiv',
      waitingTag: 'Wartend',
      humanMode: 'Mensch',
      noConversations: 'Keine Konversationen',
      selectConversation: 'Konversation auswählen',
      selectHint: 'Klicken Sie links auf eine Konversation',
      placeholder: 'Antwort eingeben...',
      returnToBot: 'Zum Bot zurück',
      close: 'Schließen',
      confirmClose: 'Möchten Sie diese Konversation wirklich schließen?',
      confirmReturnToBot: 'Möchten Sie die Kontrolle an den Bot zurückgeben?',
      conversationClosed: 'Konversation geschlossen',
      returnedToBot: 'An Bot zurückgegeben',
      botModeWarning: 'Diese Konversation wird vom Bot verwaltet.',
      takeOver: 'Übernehmen'
    }
  },

  // Chatbot
  chatbot: {
    title: 'HugoQuiz-Assistent',
    placeholder: 'Stellen Sie Ihre Frage...',
    greeting: 'Hallo! Wie kann ich Ihnen helfen?',
    talkToHuman: 'Mit Team sprechen',
    waitingForTeam: 'Warten auf Team...',
    teamResponding: 'HugoQuiz-Team',
    online: 'Online',
    conversationEnded: 'Konversation beendet'
  },

  // Tutorial
  tutorial: {
    welcome: 'Willkommen bei HugoQuiz!',
    welcomeDesc: 'Lassen Sie uns Sie durch alle Funktionen führen.',
    start: 'Tutorial starten',
    skip: 'Überspringen',
    next: 'Weiter',
    prev: 'Zurück',
    finish: 'Beenden',
    step: 'Schritt',
    of: 'von',
    steps: {
      dashboard: {
        title: 'Ihr Dashboard',
        content: 'Hier finden Sie alle Ihre Quiz, Fragebögen und Veranstaltungen.'
      },
      createQuiz: {
        title: 'Quiz erstellen',
        content: 'Klicken Sie hier, um ein neues interaktives Quiz mit Fragen und Timer zu erstellen.'
      },
      createEvent: {
        title: 'Veranstaltung erstellen',
        content: 'Verwalten Sie Hochzeiten, Geburtstage und Feiern mit Gästelisten, QR-Codes und Sitzplänen.'
      },
      settings: {
        title: 'Einstellungen',
        content: 'Passen Sie Ihr Profil an, ändern Sie die Sprache und verwalten Sie Ihre Einstellungen.'
      },
      chatbot: {
        title: 'Brauchen Sie Hilfe?',
        content: 'Unser intelligenter Assistent ist immer da, um Ihre Fragen zu beantworten!'
      }
    }
  },

  errors: {
    general: 'Ein Fehler ist aufgetreten',
    notFound: 'Seite nicht gefunden',
    unauthorized: 'Nicht autorisiert',
    tryAgain: 'Bitte versuchen Sie es erneut'
  },
  validation: {
    required: 'Dieses Feld ist erforderlich',
    email: 'Ungültige E-Mail',
    minLength: 'Mindestens {{min}} Zeichen',
    passwordMatch: 'Passwörter stimmen nicht überein'
  },
  time: {
    justNow: 'Gerade eben',
    seconds: 'Sekunden',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    ago: 'vor',
    today: 'Heute',
    yesterday: 'Gestern'
  },

  // Subscription & Pricing
  subscription: {
    title: 'Abonnement',
    mySubscription: 'Mein Abonnement',
    choosePlan: 'Wählen Sie Ihren Plan',
    subtitle: 'Leistungsstarke Tools für interaktive Quiz und Events',
    month: 'Monat',
    year: 'Jahr',
    monthly: 'Monatlich',
    yearly: 'Jährlich',
    savePercent: '{{percent}}% sparen',
    currentPlan: 'Aktueller Plan',
    popular: 'Beliebt',
    bestValue: 'Bester Wert',
    select: 'Diesen Plan wählen',
    upgrade: 'Upgraden',
    downgrade: 'Herabstufen',
    manage: 'Verwalten',
    
    plans: {
      free: 'Kostenlos',
      freeDesc: 'Zum Kennenlernen der Plattform',
      quizQuestionnaire: 'Quiz & Fragebögen',
      quizQuestionnaireDesc: 'Für Content-Ersteller',
      events: 'Events',
      eventsDesc: 'Für Eventorganisatoren',
      complete: 'Komplett',
      completeDesc: 'Zugang zu allen Funktionen',
      adminGranted: 'Gewährter Zugang',
      quizMonthly: 'Quiz & Fragebogen - Monatlich',
      eventsMonthly: 'Events - Monatlich',
      completeMonthly: 'Komplett - Monatlich',
      quizYearly: 'Quiz & Fragebogen - Jährlich',
      eventsYearly: 'Events - Jährlich',
      completeYearly: 'Komplett - Jährlich'
    },

    // Admin granted access
    adminGranted: {
      title: 'Zugang vom Administrator gewährt',
      description: 'Sie profitieren von einem kostenlosen Zugang, der von einem Administrator gewährt wurde. Dieser Zugang kann jederzeit widerrufen werden.',
      renounceTitle: 'Auf diesen Zugang verzichten',
      renounceDesc: 'Wenn Sie diesen Zugang nicht mehr benötigen, können Sie darauf verzichten und zum kostenlosen Plan zurückkehren.',
      renounceBtn: 'Auf meinen Zugang verzichten'
    },

    features: {
      quiz: 'Interaktive Quiz',
      questionnaire: 'Fragebögen',
      events: 'Events',
      participants: '{{count}} Teilnehmer max',
      participantsUnlimited: 'Unbegrenzte Teilnehmer',
      liveMode: 'Live-Modus',
      analytics: 'Detaillierte Analysen',
      export: 'Datenexport',
      support: 'Prioritäts-Support'
    },

    status: {
      active: 'Aktiv',
      expiringSoon: 'Läuft bald ab',
      expired: 'Abgelaufen',
      free: 'Kostenlos',
      cancelled: 'Gekündigt',
      past_due: 'Zahlung ausstehend',
      payment_failed: 'Zahlung fehlgeschlagen'
    },

    expiresIn: 'Läuft in {{days}} Tagen ab',
    expiringSoonWarning: 'Ihr Abonnement läuft bald ab',
    expiringSoonDesc: 'Verlängern Sie, um Zugang zu Ihren Daten zu behalten.',
    expiredWarning: 'Ihr Abonnement ist abgelaufen',
    expiredDesc: 'Ihre Fragebögen und Events werden in 30 Tagen gelöscht, wenn Sie nicht verlängern.',
    paymentFailedWarning: 'Zahlung fehlgeschlagen',
    paymentFailedDesc: 'Wir konnten Ihre Zahlung nicht verarbeiten. Bitte aktualisieren Sie Ihre Zahlungsinformationen, um Ihr Abonnement zu behalten.',
    pastDueWarning: 'Zahlung ausstehend - Kulanzfrist',
    pastDueDesc: 'Ihre Zahlung ist fehlgeschlagen, aber Sie haben eine 7-tägige Kulanzfrist. Aktualisieren Sie Ihre Zahlungsmethode, um eine Sperrung zu vermeiden.',
    gracePeriodEnds: 'Die Kulanzfrist endet in {{days}} Tagen',
    updatePaymentMethod: 'Zahlungsmethode aktualisieren',
    paymentRecovered: 'Zahlung erfolgreich! Ihr Abonnement ist wieder aktiv.',
    upgradeToPro: 'Auf Pro upgraden',
    managePayment: 'Zahlung verwalten',
    changePlan: 'Plan ändern',
    cancelSubscription: 'Abonnement kündigen',

    // Kündigung
    cancellation: {
      title: 'Kündigung',
      willNotRenew: 'Ihr Abonnement wird nicht verlängert',
      activeUntil: 'Es bleibt bis zum Ende des aktuellen Zeitraums aktiv.',
      reactivate: 'Verlängerung reaktivieren',
      refundAvailable: 'Rückerstattung verfügbar',
      refundTimeLeft: 'Sie haben noch {{minutes}} Minuten, um eine vollständige Rückerstattung zu beantragen.',
      requestRefund: 'Rückerstattung beantragen',
      cancelRenewal: 'Verlängerung kündigen',
      cancelRenewalDesc: 'Ihr Abonnement bleibt bis zum Ende des Zeitraums aktiv. Es wird keine Rückerstattung vorgenommen.',
      cancelRenewalBtn: 'Nicht verlängern',
      confirmRefund: 'Rückerstattung bestätigen',
      confirmCancel: 'Kündigung bestätigen',
      terminateTitle: 'Meinen Tarif kündigen',
      terminateDesc: 'Die Kündigung erfolgt sofort: Sie verlieren sofort die Tarifvorteile und keine Rückerstattung ist möglich.',
      terminateBtn: 'Sofort kündigen',
      terminateConfirmTitle: 'Tarif kündigen?',
      terminateWarn1: 'Der Verlust der Tarifvorteile erfolgt sofort.',
      terminateWarn2: 'Keine Rückerstattung ist möglich, gemäß den Nutzungsbedingungen.',
      terminateWarn3: 'Sie kehren sofort zum kostenlosen Tarif zurück.',
      errorTerminate: 'Fehler bei der Kündigung'
    },

    redirectingToStripe: 'Weiterleitung zu Stripe...',
    successTitle: 'Zahlung erfolgreich! 🎉',
    successMessage: 'Ihr Abonnement ist jetzt aktiv. Genießen Sie alle Funktionen!',
    cancelTitle: 'Zahlung abgebrochen',
    cancelMessage: 'Sie können es jederzeit erneut versuchen.',
    goToDashboard: 'Zum Dashboard',
    tryAgain: 'Erneut versuchen',

    errorCreatingCheckout: 'Fehler beim Erstellen der Checkout-Sitzung',
    errorOpeningPortal: 'Fehler beim Öffnen des Verwaltungsportals',
    
    // Guarantees
    guarantee: {
      cancel: 'Jederzeit kündbar',
      secure: 'Sichere Zahlung',
      support: 'Support inklusive'
    },
    
    // Subscription management
    manageExisting: 'Mein bestehendes Abonnement verwalten oder kündigen',
    perMonth: 'pro Monat',
    perYear: 'pro Jahr',
    save: 'Sparen Sie',
    subscribe: 'Abonnieren',
    currentPlanBadge: 'Ihr aktueller Plan',
    unlimitedQuiz: 'Unbegrenzte Quiz',
    noQuiz: 'Quiz nicht inklusive',
    unlimitedQuestionnaire: 'Unbegrenzte Fragebögen',
    noQuestionnaire: 'Fragebögen nicht inklusive',
    unlimitedEvents: 'Unbegrenzte Events',
    noEvents: 'Events nicht inklusive',
    unlimitedParticipants: 'Unbegrenzte Teilnehmer',
    startTrial: '7 Tage kostenlos testen',
    trialNotEligible: 'Sie sind nicht für die kostenlose Testversion berechtigt',
    
    // Trial
    trial: {
      banner: '7 Tage kostenlos testen!',
      bannerDesc: 'Testen Sie alle Funktionen ohne Verpflichtung. Jederzeit kündbar.',
      cardRequired: 'Kreditkarte erforderlich',
      alreadyUsed: 'Sie haben Ihre kostenlose Testversion bereits genutzt.',
      adminGranted: 'Die kostenlose Testversion ist nicht für Konten verfügbar, die kostenlosen Zugang erhalten haben.',
      notEligible: 'Sie sind nicht für die kostenlose Testversion berechtigt.',
      modalTitle: '7 Tage kostenlose Testversion',
      benefit1: 'Voller Zugang zu allen Funktionen für 7 Tage',
      benefit2: 'Jederzeit vor Ende der Testphase kündbar',
      warning: 'Kreditkarte erforderlich. Automatische Abbuchung von {{price}}€/Monat am 8. Tag, wenn nicht gekündigt.',
      uniqueOffer: 'Die kostenlose Testversion ist nur einmal pro Benutzer verfügbar, unabhängig vom gewählten Tarif.',
      confirm: 'Testversion starten',
      active: 'Kostenlose Testversion aktiv',
      endsIn: 'Endet in {{days}} Tagen',
      endsToday: 'Endet heute',
      chargeDate: 'Erste Abbuchung geplant am {{date}}',
      endsOn: 'Testversion endet am {{date}}',
      cancelAnytime: 'Jederzeit kostenlos kündbar',
      cancelBtn: 'Kostenlose Testversion kündigen',
      confirmCancel: 'Sind Sie sicher, dass Sie Ihre kostenlose Testversion kündigen möchten? Sie kehren zum kostenlosen Tarif zurück und können keine neue Testversion mehr nutzen.',
      errorCancel: 'Fehler beim Kündigen der Testversion'
    },
    
    freeFeatures: {
      quiz: 'Quiz (max. 5 Teilnehmer)',
      questionnaire: 'Fragebögen',
      events: 'Events'
    }
  },

  pricing: {
    title: 'Preise',
    heroTitle: 'Pläne für Ihre Bedürfnisse',
    heroSubtitle: 'Starten Sie kostenlos, skalieren Sie nach Bedarf',
    faq: 'Häufig gestellte Fragen',
    allFeaturesIncluded: 'Alle Funktionen inklusive',
    perMonth: '/Monat',
    perYear: '/Jahr',
    startFree: 'Kostenlos starten',
    getStarted: 'Loslegen'
  },

  // Seating Plan
  seatingPlan: {
    title: 'Sitzplan',
    loading: 'Sitzplan wird geladen...',
    unsaved: 'Nicht gespeichert',
    saved: 'Plan gespeichert!',
    save: 'Speichern',
    unplacedGuests: 'Nicht platzierte Gäste',
    allGuestsPlaced: 'Alle Gäste sind platziert!',
    addTable: 'Tisch hinzufügen',
    addElement: 'Element hinzufügen',
    entrance: 'Eingang',
    mainEntrance: 'Haupteingang',
    stage: 'Bühne',
    entranceAdded: 'Eingang hinzugefügt',
    stageAdded: 'Bühne hinzugefügt',
    dimensions: 'Plan-Dimensionen',
    width: 'Breite',
    height: 'Höhe',
    default: 'Standard',
    large: 'Groß',
    extraLarge: 'Sehr groß',
    xxl: 'XXL',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    resetView: 'Ansicht zurücksetzen',
    fullscreen: 'Vollbild',
    adjustDimensions: 'Dimensionen anpassen',
    toggleInitials: 'Initialen ein-/ausblenden',
    noTables: 'Noch keine Tische',
    createFirstTable: 'Ersten Tisch erstellen',
    color: 'Farbe',
    shape: 'Form',
    size: 'Größe',
    guests: 'Gäste',
    dragGuestsHere: 'Gäste hierher ziehen',
    deleteTable: 'Tisch löschen',
    confirmDeleteTable: 'Tisch "{{name}}" löschen?',
    newTable: 'Neuer Tisch',
    tableName: 'Tischname',
    tableNamePlaceholder: 'Tisch 1, Ehrentisch...',
    capacity: 'Kapazität (Personen)',
    create: 'Erstellen'
  },

  // Table Management
  tableManagement: {
    title: 'Tischverwaltung',
    guestList: 'Gästeliste',
    addTable: 'Tisch hinzufügen',
    tables: 'Tische',
    totalCapacity: 'Gesamtkapazität',
    seatedGuests: 'Platzierte Gäste',
    notSeated: 'Nicht platziert',
    noGuestAssigned: 'Kein Gast zugewiesen',
    removeFromTable: 'Vom Tisch entfernen',
    add: 'Hinzufügen',
    noTableCreated: 'Keine Tische erstellt',
    createFirstTable: 'Ersten Tisch erstellen',
    unplacedGuests: 'Nicht platzierte Gäste',
    place: 'Platzieren →',
    addTableTitle: 'Tisch hinzufügen',
    tableNameLabel: 'Tischname *',
    tableNamePlaceholder: 'Z.B.: Brauttisch, Tisch 1...',
    capacityLabel: 'Kapazität (Personenzahl)',
    createTable: 'Tisch erstellen',
    editTableTitle: 'Tisch bearbeiten',
    addTo: 'Zu {{name}} hinzufügen',
    allGuestsSeated: 'Alle Gäste sind bereits platziert',
    confirmDelete: 'Löschung bestätigen',
    confirmDeleteMessage: 'Sind Sie sicher, dass Sie den Tisch löschen möchten',
    guestsWillBeUnassigned: 'Gäste an diesem Tisch werden als "nicht platziert" markiert.',
    present: 'Anwesend',
    absent: 'Abwesend',
    markPresent: 'Als anwesend markieren',
    markAbsent: 'Als abwesend markieren',
    presenceChanged: '{{name}} als {{status}} markiert',
    presenceError: 'Fehler beim Ändern des Status',
    presentCount: '{{count}}/{{total}} anwesend',
    sortLabel: 'Tische sortieren',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortCapacityDesc: 'Kapazität (absteigend)',
    sortCapacityAsc: 'Kapazität (aufsteigend)',
    sortOccupancyDesc: 'Belegung (absteigend)',
    sortOccupancyAsc: 'Belegung (aufsteigend)'
  },

  // QR Scanner
  qrScanner: {
    title: 'QR-Code Scanner',
    guestList: 'Gästeliste',
    tables: 'Tische',
    scanTicket: 'Ticket scannen',
    scanInstructions: 'Richten Sie die Kamera auf den QR-Code des Einladungstickets',
    coupleTicket: 'Paar-Ticket - Person auswählen',
    present: 'ANWESEND',
    absent: 'ABWESEND',
    name: 'Name',
    gender: 'Geschlecht',
    male: 'Mann',
    female: 'Frau',
    ticketType: 'Tickettyp',
    couple: 'Paar',
    single: 'Einzeln',
    organizerRelation: 'Beziehung zum Veranstalter',
    assignedTable: 'Zugewiesener Tisch',
    coupleStatus: 'Paarstatus',
    presentStatus: 'Anwesend',
    absentStatus: 'Abwesend',
    presentFemale: 'Anwesend',
    absentFemale: 'Abwesend',
    markPresent: 'Als anwesend markieren',
    markAbsent: 'Als abwesend markieren',
    scanAnother: 'Weiteres Ticket scannen',
    instructions: 'Anleitung',
    instruction1: 'Scannen Sie den QR-Code auf dem Einladungsticket',
    instruction2: 'Überprüfen Sie die Gastinformationen',
    instruction3: 'Ändern Sie bei Bedarf den Anwesenheitsstatus',
    instruction4: 'Bei Paar-Tickets wählen Sie die betreffende Person',
    instruction5: 'Sie können dasselbe Ticket mehrmals scannen',
    markedAs: '{{name}} als {{status}} markiert'
  },

  // Questionnaire Responses
  questionnaireResponses: {
    title: 'Fragebogen-Antworten',
    loading: 'Antworten werden geladen...',
    respondents: 'Befragte',
    questions: 'Fragen',
    completed: 'Abgeschlossen',
    respondentList: 'Liste der Befragten',
    noResponses: 'Noch keine Antworten',
    shareToReceive: 'Teilen Sie Ihren Fragebogen, um Antworten zu erhalten',
    anonymous: 'Anonym',
    noAnswer: 'Keine Antwort',
    answers: 'Antworten',
    abandoned: 'Abgebrochen',
    completedStatus: 'Abgeschlossen',
    inProgress: 'In Bearbeitung',
    responseDetails: 'Antwortdetails',
    sessionAbandoned: 'Sitzung abgebrochen',
    noQuestionsAnswered: 'Diese Person hat den Fragebogen begonnen, aber keine Fragen beantwortet.',
    viewFullResults: 'Vollständige Ergebnisseite anzeigen',
    deleteResponse: 'Diese Antwort löschen?',
    deleteResponseMessage: 'Die Antwort von <strong>{{name}}</strong> wird dauerhaft gelöscht.',
    responseOf: 'Die Antwort von'
  },

  // Quiz Responses
  quizResponses: {
    loading: 'Antworten werden geladen...',
    title: 'Quiz-Antworten',
    participants: 'Teilnehmer',
    averageScore: 'Durchschnittspunktzahl',
    averageSuccessRate: 'Durchschnittliche Erfolgsquote',
    participantsList: 'Teilnehmerliste',
    noResponses: 'Noch keine Antworten',
    shareQuiz: 'Teilen Sie Ihr Quiz, um Antworten zu erhalten',
    abandoned: 'Abgebrochen',
    responseDetails: 'Antwortdetails',
    answer: 'Antwort',
    correctAnswer: 'Richtige Antwort',
    sessionAbandoned: 'Sitzung abgebrochen',
    noQuestionsAnswered: 'Diese Person hat das Quiz begonnen, aber keine Fragen beantwortet.',
    viewFullResults: 'Vollständige Ergebnisseite anzeigen',
    deleteResponse: 'Diese Antwort löschen?',
    responseOf: 'Die Antwort von'
  },

  // Quiz Results
  quizResults: {
    loading: 'Ergebnisse werden geladen...',
    title: 'Quiz-Ergebnisse',
    totalScore: 'Gesamtpunktzahl',
    correct: 'Richtig',
    incorrect: 'Falsch',
    success: 'Erfolg',
    viewLeaderboard: 'Rangliste anzeigen',
    responseDetails: 'Antwortdetails',
    viewAll: 'Alle anzeigen',
    revisionMode: 'Wiederholungsmodus',
    revisionModeActive: 'Wiederholungsmodus aktiv',
    showingIncorrect: 'Zeigt nur {{count}} falsche Antwort(en) an',
    yourAnswer: 'Ihre Antwort',
    noAnswer: 'Keine Antwort',
    correctAnswer: 'Richtige Antwort',
    points: 'Punkte',
    time: 'Zeit',
    replay: 'Nochmal spielen',
    home: 'Startseite'
  },

  // Quiz Leaderboard
  quizLeaderboard: {
    loading: 'Rangliste wird geladen...',
    title: 'Rangliste',
    share: 'Teilen',
    uniquePlayers: 'Einzigartige Spieler',
    gamesPlayed: 'Gespielte Spiele',
    highestScore: 'Höchste Punktzahl',
    averageScore: 'Durchschnittspunktzahl',
    filterAll: 'Alle',
    filterToday: 'Heute',
    filterWeek: '7 Tage',
    filterMonth: '30 Tage',
    noScores: 'Noch keine Punkte',
    beFirst: 'Sei der Erste, der spielt!',
    playNow: 'Jetzt spielen',
    points: 'Punkte',
    joinLeaderboard: 'Spielen und der Rangliste beitreten'
  },

  // Join Quiz Live
  joinQuizLive: {
    loading: 'Suche nach einer aktiven Sitzung...',
    liveSession: 'Live-Sitzung!',
    playersWaiting: '{{count}} Spieler wartet/warten',
    joinSession: 'Sitzung beitreten',
    noSession: 'Keine aktive Sitzung',
    hostNotStarted: 'Der Gastgeber hat noch keine Sitzung gestartet',
    hasSessionCode: 'Haben Sie einen Sitzungscode?',
    sessionCodePlaceholder: 'Sitzungscode...',
    or: 'oder',
    playSolo: 'Alleine spielen',
    questions: 'Fragen',
    perQuestion: 's pro Frage'
  },

  // Event Visitors
  eventVisitors: {
    title: 'Registrierte Besucher',
    refresh: 'Aktualisieren',
    totalVisitors: 'Besucher gesamt',
    pdfDownloaded: 'PDFs heruntergeladen',
    lastVisit: 'Letzter Besuch',
    visitorsList: 'Besucherliste',
    registeredOn: 'Registriert am',
    pdfDownloadedStatus: 'PDF heruntergeladen',
    noPdf: 'Kein PDF',
    generatePdf: 'PDF generieren',
    noVisitors: 'Keine registrierten Besucher',
    visitorsWillAppear: 'Besucher werden hier erscheinen, wenn sie ihren Namen eingeben',
    deleteVisitor: 'Diesen Besucher löschen?',
    deleteVisitorConfirm: 'Möchten Sie {{name}} wirklich aus der Liste löschen?',
    backToDashboard: 'Zurück zum Dashboard',
    eventNotFound: 'Ereignis nicht gefunden',
    unauthorized: 'Sie sind nicht berechtigt, diese Seite zu sehen',
    loadingError: 'Fehler beim Laden der Daten',
    pdfGenerated: 'PDF für {{name}} generiert',
    pdfError: 'Fehler beim Generieren des PDFs',
    visitorDeleted: 'Besucher gelöscht',
    deleteError: 'Fehler beim Löschen',
    invitation: 'Einladung'
  },

  // Planning (Programs & Menus)
  planning: {
    title: 'Planung',
    subtitle: 'Verwalten Sie Programme und Menüs Ihrer Veranstaltung',
    programs: 'Programme',
    menus: 'Menüs',
    shareLinks: 'Freigabelinks',
    createProgram: 'Programm erstellen',
    editProgram: 'Programm bearbeiten',
    createMenu: 'Menü erstellen',
    editMenu: 'Menü bearbeiten',
    noProgramsYet: 'Keine Programme erstellt',
    noMenusYet: 'Keine Menüs erstellt',
    noLinksYet: 'Keine Freigabelinks generiert',
    generateQR: 'QR-Code / Link generieren',
    generateQRTitle: 'Freigabelink generieren',
    generateQRDescription: 'Wählen Sie die Elemente aus, die Sie mit Ihren Gästen teilen möchten',
    editQRTitle: 'QR-Code bearbeiten',
    editQRDescription: 'Elemente hinzufügen oder entfernen. QR-Code und Link bleiben gleich.',
    saveChanges: 'Speichern',
    linkUpdated: 'QR-Code aktualisiert!',
    generate: 'Generieren',
    downloadQR: 'QR herunterladen',
    noContentToShare: 'Kein Inhalt zum Teilen',
    createContentFirst: 'Erstellen Sie zuerst Programme oder Menüs',
    includeGuestbook: 'Gästebuch einbeziehen',
    confirmDeleteProgram: 'Möchten Sie dieses Programm wirklich löschen?',
    confirmDeleteMenu: 'Möchten Sie dieses Menü wirklich löschen?',
    selectToView: 'Wählen Sie, was Sie ansehen möchten',
    invalidLink: 'Dieser Freigabelink ist nicht mehr gültig',
    eventNotFound: 'Veranstaltung nicht gefunden',
    noContentAvailable: 'Kein Inhalt verfügbar',
    program: {
      info: 'Programminformationen',
      title: 'Programmtitel',
      titlePlaceholder: 'Z.B.: Der Tagesablauf',
      titleRequired: 'Titel ist erforderlich',
      date: 'Datum / Zeitraum',
      datePlaceholder: 'Z.B.: Samstag, 14. Juni',
      dateHint: 'Freitext - schreiben Sie wie Sie möchten',
      items: 'Aktivitäten',
      addItem: 'Aktivität hinzufügen',
      addFirstItem: 'Erste Aktivität hinzufügen',
      noItems: 'Keine Aktivitäten in diesem Programm',
      activityName: 'Aktivitätsname',
      activityNamePlaceholder: 'Z.B.: Gästeempfang',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Beschreiben Sie diese Aktivität...',
      bgColor: 'Hintergrundfarbe',
      textColor: 'Textfarbe',
      images: 'Bilder',
      viewMap: 'Karte anzeigen',
      activities: 'Aktivitäten'
    },
    menu: {
      info: 'Menüinformationen',
      title: 'Menütitel',
      titlePlaceholder: 'Z.B.: Gala-Dinner-Menü',
      titleRequired: 'Titel ist erforderlich',
      starters: 'Vorspeisen',
      mains: 'Hauptgerichte',
      desserts: 'Desserts',
      dish: 'Gericht',
      addDish: 'Gericht hinzufügen',
      dishName: 'Gerichtname',
      dishNamePlaceholder: 'Z.B.: Hausgemachte Foie Gras',
      dishDescription: 'Gerichtbeschreibung',
      dishDescriptionPlaceholder: 'Beschreiben Sie dieses Gericht...',
      dishImage: 'Gerichtbild'
    },
    editor: {
      bold: 'Fett',
      italic: 'Kursiv',
      textColor: 'Textfarbe',
      mapLinkPlaceholder: 'Google Maps-Link...'
    }
  },

  // Image Upload
  imageUpload: {
    import: 'Importieren',
    urlPlaceholder: 'https://beispiel.com/bild.jpg',
    uploadInProgress: 'Upload läuft...',
    imageUploaded: 'Bild hochgeladen',
    deleteImage: 'Bild löschen',
    clickToSelect: 'Klicken Sie, um ein Bild auszuwählen',
    maxSize: 'PNG, JPG, GIF bis zu 5 MB',
    preview: 'Vorschau',
    selectImage: 'Bitte wählen Sie ein Bild aus',
    maxSizeError: 'Das Bild darf nicht größer als 60 MB sein',
    maxSizeErrorWithSize: 'Das Bild darf nicht größer als {{size}} MB sein',
    storageNotConfigured: 'Firebase Storage ist nicht konfiguriert. Bitte aktivieren Sie Storage in der Firebase-Konsole.'
  },

  // Tasks
  tasks: {
    title: 'Aufgaben',
    add: 'Aufgabe hinzufügen',
    addFirst: 'Meine erste Aufgabe hinzufügen',
    selectTask: 'Aufgabe auswählen',
    selectTaskDescription: 'Wählen Sie eine vordefinierte Aufgabe oder erstellen Sie eine eigene',
    createCustom: 'Eigene Aufgabe erstellen',
    predefined: 'Vordefinierte Hochzeitsaufgaben',
    newTask: 'Neue Aufgabe',
    editTask: 'Aufgabe bearbeiten',
    taskName: 'Aufgabenname',
    taskNamePlaceholder: 'Z.B.: Fotografen buchen',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Beschreiben Sie die Details dieser Aufgabe...',
    deadline: 'Frist',
    cost: 'Geschätzte Kosten',
    responsibles: 'Verantwortliche',
    responsibleName: 'Name',
    responsibleContact: 'Telefon / E-Mail',
    addResponsible: 'Verantwortlichen hinzufügen',
    location: 'Standort',
    locationNamePlaceholder: 'Ortsname (z.B.: Fotostudio Martin)',
    locationUrlPlaceholder: 'Google Maps-Link oder Wegbeschreibung',
    directions: 'Wegbeschreibung',
    reminder: 'Erinnerung',
    reminderOn: 'Erinnerung aktiv',
    setReminder: 'Erinnerung einstellen',
    configure: 'Konfigurieren',
    venue: 'Veranstaltungsort',
    quantity: 'Menge',
    notes: 'Notizen',
    notesPlaceholder: 'Zusätzliche Notizen...',
    responses: 'Fortschrittsaktualisierungen',
    addResponse: 'Aktualisierung hinzufügen...',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?',
    all: 'Alle',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    overdue: 'Überfällig',
    search: 'Aufgaben suchen...',
    empty: 'Keine Aufgaben',
    emptyDescription: 'Beginnen Sie mit der Planung Ihres Events, indem Sie Aufgaben hinzufügen',
    markComplete: 'Als abgeschlossen markieren',
    markIncomplete: 'Als nicht abgeschlossen markieren',
    today: 'Heute',
    tomorrow: 'Morgen',
    daysLeft: '{{days}} Tage übrig'
  },

  // Notifications
  notifications: {
    title: 'Benachrichtigungen',
    empty: 'Keine Benachrichtigungen',
    emptyDescription: 'Sie erhalten hier Aufgaben-Erinnerungen',
    markAllRead: 'Alle als gelesen markieren',
    markRead: 'Als gelesen markieren',
    viewAll: 'Alle Benachrichtigungen anzeigen',
    new: 'Neu',
    justNow: 'Gerade eben',
    minutesAgo: 'Vor {{count}} Min.',
    hoursAgo: 'Vor {{count}} Std.',
    daysAgo: 'Vor {{count}} T.',
    today: 'Heute',
    yesterday: 'Gestern',
    all: 'Alle',
    unread: 'Ungelesen',
    read: 'Gelesen',
    unreadCount: '{{count}} ungelesen',
    allRead: 'Alle Benachrichtigungen gelesen',
    noUnread: 'Keine ungelesenen Benachrichtigungen',
    noRead: 'Keine gelesenen Benachrichtigungen',
    chatEscalation: '💬 Neuer Chat wartet',
    chatEscalationMessage: '{{userName}} bittet um menschliche Hilfe',
    goToChat: 'Chat anzeigen'
  },

  // Questionnaire Results
  questionnaireResults: {
    loading: 'Ergebnisse werden geladen...',
    title: 'Ihre Antworten',
    completedOn: 'Fragebogen abgeschlossen am',
    unknownDate: 'Unbekanntes Datum',
    answersRecorded: 'Antworten aufgezeichnet',
    responseDetails: 'Antwortdetails',
    noAnswer: 'Keine Antwort',
    noAnswersRecorded: 'Keine Antworten aufgezeichnet',
    backToHome: 'Zurück zur Startseite'
  },

  // Admin Quiz Music
  adminQuizMusic: {
    loading: 'Musik wird geladen...',
    title: 'Quiz-Musik-Verwaltung',
    subtitle: 'Verwalten Sie Lobby-Musik, Soundeffekte und Gameplay-Musik',
    backToAdmin: 'Zurück zum Admin-Panel',
    lobbyTab: 'Lobby',
    effectsTab: 'Effekte',
    gameplayTab: 'Gameplay',
    lobbyMusic: 'Lobby-Musik',
    lobbyMusicDesc: 'Diese Musik wird im Warteraum zufällig in Schleife abgespielt.',
    soundEffects: 'Soundeffekte',
    soundEffectsDesc: 'Diese Sounds werden zu bestimmten Zeitpunkten im Quiz abgespielt.',
    gameplayMusic: 'Gameplay-Musik',
    gameplayMusicDesc: 'Jede Fragendauer hat ihre eigene Musikbank.',
    questionDuration: '{{duration}}s Frage → ~{{musicDuration}}s Musik',
    lobbyMusicTitle: '🎵 Lobby-Musik',
    lobbyMusicSubtitle: 'Wird zufällig im Warteraum abgespielt',
    countdownTitle: '⏱️ Countdown (3-2-1)',
    countdownSubtitle: 'Sound vor Spielbeginn',
    transitionTitle: '🔄 Fragenübergang',
    transitionSubtitle: 'Kurzer Sound zwischen Fragen',
    resultsTitle: '📊 Ergebnisse / Statistiken',
    resultsSubtitle: 'Musik während der Ergebnisanzeige',
    podiumTitle: '🏆 Finales Podium',
    podiumSubtitle: 'Festliche Musik für das Podium',
    questionsTitle: '🎮 {{duration}}s Fragen',
    questionsSubtitle: 'Musik für {{duration}}-Sekunden-Fragen',
    uploading: 'Upload läuft...',
    addAudio: 'Klicken Sie, um Audiodateien hinzuzufügen',
    noMusic: 'Keine Musik',
    unknownError: 'Unbekannter Fehler'
  },

  services: {
    marketplaceTitle: 'Finden Sie den richtigen Anbieter',
    marketplaceSubtitle: 'Vertrauenswürdige Fachleute für all Ihre Bedürfnisse und Projekte.',
    searchPlaceholder: 'Service oder Unternehmen suchen...',
    noServices: 'Noch keine Services',
    noServicesDesc: 'Seien Sie der Erste, der seinen Service in dieser Kategorie anbietet.',
    proposeService: 'Service anbieten',
    onQuote: 'Auf Anfrage',
    views: 'Aufrufe',
    window: 'Tab',
    notFound: 'Service nicht gefunden',
    notYours: 'Dieser Service gehört Ihnen nicht',
    updated: 'Service aktualisiert!',
    submitted: 'Service eingereicht! Er wird nach Prüfung veröffentlicht.',
    createService: 'Service erstellen',
    editTitle: 'Service bearbeiten',
    createSubtitle: 'Präsentieren Sie Ihr Angebot klar und ansprechend.',
    autoTranslateHint: 'Ihre Texte werden bei der Veröffentlichung automatisch in die anderen Sprachen (Französisch, Englisch, Niederländisch) übersetzt.',
    generalInfo: 'Allgemeine Informationen',
    businessName: 'Firmenname',
    serviceTitle: 'Service-Titel',
    titlePlaceholder: 'z. B. Professioneller Fotograf & Videograf',
    tagline: 'Slogan',
    taglinePlaceholder: 'Ein kurzer Satz, der Ihr Angebot zusammenfasst',
    category: 'Kategorie',
    serviceType: 'Service-Typ',
    country: 'Land',
    city: 'Stadt',
    cityPlaceholder: 'Wählen oder geben Sie Ihre Stadt ein',
    coverImage: 'Titelbild',
    profilePhoto: 'Profilfoto',
    profilePhotoHint: 'Wenn Sie kein Foto hinzufügen, werden die Initialen Ihres Namens angezeigt.',
    price: 'Preis (optional)',
    pricePlaceholder: 'z. B. Ab 350 € / Auf Anfrage',
    priceComment: 'Hinweis zum Preis',
    priceCommentPlaceholder: 'z. B. für eine 2-stündige Leistung',
    contactInfo: 'Kontaktdaten',
    contactInfoDesc: 'Wählen Sie, welche Daten für Besucher sichtbar sind. Ein Kontaktformular wird immer angezeigt.',
    email: 'E-Mail',
    showEmail: 'Meine E-Mail öffentlich anzeigen',
    phone: 'Telefon',
    showPhone: 'Meine Nummer öffentlich anzeigen',
    windows: 'Fenster / Tabs',
    addWindow: 'Tab hinzufügen',
    windowTitle: 'Tab-Titel (z. B. Hochzeit)',
    imageBlock: 'Bild',
    textBlock: 'Text',
    textPlaceholder: 'Schreiben Sie Ihren Absatz...',
    captionPlaceholder: 'Bildunterschrift (optional)',
    noBlocks: 'Fügen Sie Text oder Bilder zu diesem Tab hinzu.',
    addText: 'Text hinzufügen',
    addImage: 'Bild hinzufügen',
    verifyFirst: 'Verifizieren Sie zuerst Ihre Identität',
    verifyFirstDesc: 'Um einen Service zu veröffentlichen, müssen Sie zuerst Ihre Identität bestätigen. Dies ist ein einmaliger, sicherer Schritt.',
    startVerification: 'Verifizierung starten',
    notAvailable: 'Service nicht verfügbar',
    notAvailableDesc: 'Dieser Service existiert nicht oder ist noch nicht veröffentlicht.',
    backToMarketplace: 'Alle Services',
    previewPending: 'Vorschau — dieser Service wartet auf die Freigabe durch einen Administrator.',
    previewRejected: 'Dieser Service wurde abgelehnt.',
    previewRestricted: 'Die Anzeige dieses Service wurde von einem Administrator eingeschränkt.',
    emptyWindow: 'Kein Inhalt in diesem Tab.',
    errors: {
      businessName: 'Geben Sie den Firmennamen ein.',
      title: 'Geben Sie einen Titel für Ihren Service ein.',
      type: 'Wählen Sie einen Service-Typ.',
      country: 'Wählen Sie Ihr Land.',
      city: 'Geben Sie Ihre Stadt ein.',
      email: 'Geben Sie eine Kontakt-E-Mail ein.'
    },
    status: {
      pending: 'Wartet auf Prüfung',
      approved: 'Veröffentlicht',
      rejected: 'Abgelehnt',
      restricted: 'Eingeschränkt'
    },
    categories: {
      evenement: 'Veranstaltungen', maison: 'Haus & Handwerk', beaute: 'Schönheit & Wellness', formation: 'Kurse & Ausbildung', digital: 'IT & Digital', mode: 'Mode & Nähen', transport: 'Transport & Lieferung', autre: 'Andere Services'
    },
    types: {
      photographe: 'Fotograf', videaste: 'Videograf', 'event-planner': 'Event-Planer', dj: 'DJ', traiteur: 'Catering', decoration: 'Dekoration', animation: 'Unterhaltung', 'location-salle': 'Saalvermietung', fleuriste: 'Florist', musicien: 'Musiker', mc: 'Zeremonienmeister', securite: 'Sicherheit', plombier: 'Klempner', electricien: 'Elektriker', menuisier: 'Schreiner', peintre: 'Maler', jardinier: 'Gärtner', demenagement: 'Umzug', nettoyage: 'Reinigung', bricolage: 'Handwerker', coiffeur: 'Friseur', maquilleur: 'Make-up-Artist', estheticienne: 'Kosmetikerin', manucure: 'Maniküre', massage: 'Massage', 'coach-sportif': 'Fitnesstrainer', 'cours-particuliers': 'Privatunterricht', langues: 'Sprachen', musique: 'Musik', 'soutien-scolaire': 'Nachhilfe', coaching: 'Coaching', developpeur: 'Entwickler', graphiste: 'Grafikdesigner', webdesign: 'Webdesign', marketing: 'Marketing', redaction: 'Texterstellung', 'community-manager': 'Community-Manager', couture: 'Nähen', stylisme: 'Styling', retouche: 'Änderungen', creation: 'Gestaltung', chauffeur: 'Fahrer', livraison: 'Lieferung', vtc: 'Mietwagen', demenageur: 'Umzugshelfer', autre: 'Andere'
    },
    idDocuments: {
      'carte-identite': 'Personalausweis', 'passeport-ue': 'Reisepass (Europäische Union)', 'carte-sejour': 'Aufenthaltstitel', visa: 'Visum', 'permis-conduire': 'Führerschein'
    },
    marketplace: {
      navLink: 'Services',
      homeTitle: 'Finden Sie den idealen Anbieter',
      homeSubtitle: 'Fotografen, DJs, Caterer, Event-Planer und mehr — geprüfte Fachleute für all Ihre Projekte.',
      browseAll: 'Services durchsuchen',
      becomeProvider: 'Meine Services anbieten'
    },
    verify: {
      title: 'Identitätsprüfung',
      subtitle: 'Ein einmaliger Schritt, um vertrauenswürdiger Anbieter zu werden.',
      approvedTitle: 'Identität bestätigt ✅',
      approvedDesc: 'Sie können jetzt Ihre Services erstellen und veröffentlichen.',
      pendingTitle: 'Prüfung läuft',
      pendingDesc: 'Unser Team prüft Ihre Anfrage. Sie werden per E-Mail und in Ihren Benachrichtigungen informiert, sobald sie bearbeitet wurde.',
      rejectedTitle: 'Vorherige Anfrage abgelehnt',
      resubmit: 'Sie können unten neue Dokumente einreichen.',
      explain: 'Um die Plattform sicher zu halten, prüfen wir die Identität jedes Anbieters. Stellen Sie ein gültiges Ausweisdokument bereit und nehmen Sie ein kurzes Video von sich auf, damit unser Team bestätigen kann, dass die Identität zu Ihnen passt. Diese Dokumente sind vertraulich und werden ausschließlich zur Verifizierung verwendet.',
      idType: 'Art des Ausweisdokuments',
      idDocument: 'Ausweisdokument (Bild oder PDF)',
      uploadFile: 'Hochladen (Bild / PDF)',
      scanFile: 'Mit Kamera scannen',
      selfieVideo: 'Live-Selfie-Video',
      selfieHint: 'Filmen Sie sich einige Sekunden von vorne. Mit diesem Video können wir Ihr Gesicht mit Ihrem Ausweis vergleichen.',
      consent: 'Ich stimme zu, dass mein Ausweisdokument und mein Video von HugoQuiz zu Verifizierungszwecken verarbeitet werden, gemäß den Nutzungsbedingungen und der Datenschutzrichtlinie.',
      submit: 'Verifizierungsanfrage einreichen',
      submitted: 'Ihre Anfrage wurde an unser Team gesendet.',
      invalidIdFile: 'Bitte stellen Sie ein Bild oder ein PDF bereit.',
      fileTooLarge: 'Datei zu groß (max. 30 MB).',
      needId: 'Bitte stellen Sie Ihr Ausweisdokument bereit.',
      needSelfie: 'Bitte nehmen Sie Ihr Selfie-Video auf.',
      needConsent: 'Sie müssen die Bedingungen akzeptieren.',
      cameraError: 'Kein Zugriff auf die Kamera möglich. Erlauben Sie den Zugriff und versuchen Sie es erneut.',
      enableCamera: 'Kamera aktivieren',
      recorded: 'Video aufgenommen',
      startRecording: 'Start',
      stopRecording: 'Stopp',
      retake: 'Wiederholen'
    },
    contact: {
      title: 'Kontakt',
      intro: 'Beschreiben Sie Ihren Bedarf oder Ihr Projekt genau und wir melden uns so schnell wie möglich bei Ihnen.',
      fullName: 'Vollständiger Name',
      phone: 'Telefonnummer',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'sie@beispiel.com',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail ein.',
      clientType: 'Kundentyp',
      individual: 'Privatperson',
      company: 'Unternehmen',
      subject: 'Betreff der Anfrage',
      request: 'Beschreiben Sie Ihre Anfrage / den gewünschten Service',
      send: 'Anfrage senden',
      sent: 'Ihre Anfrage wurde gesendet!',
      sentTitle: 'Anfrage gesendet!',
      sentDesc: 'Der Anbieter hat Ihre Nachricht erhalten und meldet sich bald.',
      fillRequired: 'Bitte füllen Sie die Pflichtfelder aus.',
      consentRequired: 'Sie müssen der Verarbeitung Ihrer Daten zustimmen.',
      consent: 'Ich stimme zu, dass meine Daten an den Anbieter weitergegeben werden, damit er auf meine Anfrage antworten kann.'
    },
    reviews: {
      title: 'Bewertungen',
      rating: 'Bewertung',
      ratings: 'Bewertungen',
      customerReviews: 'Kundenbewertungen',
      summaryDesc: 'Teilen Sie Ihre Erfahrung mit diesem Anbieter, um anderen Kunden zu helfen.',
      writeReview: 'Bewertung schreiben',
      yourReview: 'Ihre Bewertung',
      yourRating: 'Ihre Note',
      yourName: 'Ihr Name',
      yourComment: 'Ihr Kommentar',
      optional: 'optional',
      commentPlaceholder: 'Beschreiben Sie Ihre Erfahrung…',
      commentModerated: 'Kommentare werden vor der Veröffentlichung von einem Administrator geprüft.',
      submit: 'Bewertung veröffentlichen',
      submitted: 'Danke für Ihre Bewertung!',
      submittedPending: 'Danke! Ihr Kommentar wird nach der Prüfung veröffentlicht.',
      pendingNote: 'Ihr Kommentar wartet auf die Freigabe durch einen Administrator.',
      alreadyReviewed: 'Sie haben diesen Service bereits bewertet.',
      noReviews: 'Noch keine Bewertungen. Seien Sie der Erste!',
      anonymous: 'Anonym',
      pickRating: 'Bitte vergeben Sie eine Note.',
      enterName: 'Bitte geben Sie Ihren Namen ein.'
    },
    messages: {
      title: 'Erhaltene Nachrichten',
      subtitle: 'Anfragen, die über Ihre Services gesendet werden, erscheinen hier.',
      empty: 'Noch keine Nachrichten'
    }
  }
}
